// {{{ Supervisor.OverviewScreen

GW.define('Supervisor.OverviewScreen', 'Main.Screen', {
	title: _('Supervizor panel'),
	titleIcon: 'eye',

	'after:initComponent'() {
		this.bodyEl.classList.add('column-panel')
		this.bodyEl.gwReplaceChildren([{
			className: 'day-stats',
			xtype: 'Supervisor.DayStatsBar',
		},{
			className: 'tab-switcher',
			xtype: 'Widgets.TabSwitcher',
			autofocusActive: true,
			ref: 'tabs',
			items: [{
				id: 'active-calls',
				title: _('Aktivní a čekající hovory'),
				href: APP_BASE + 'supervisor/active-calls',
			}, {
				id: 'agents',
				title: _('Agenti'),
				href: APP_BASE + 'supervisor/agents',
			}, {
				id: 'queues',
				title: _('Fronty'),
				href: APP_BASE + 'supervisor/queues',
			}, {
				id: 'callbacks',
				title: _('Callback'),
				href: APP_BASE + 'supervisor/callbacks',
			}, {
				id: 'queues-history',
				title: _('Historie front'),
				href: APP_BASE + 'supervisor/queues-history',
			}, {
				id: 'announce',
				title: _('Oznámení'),
				href: APP_BASE + 'supervisor/announce',
			}, {
				':skip': !env.IS_BCCP23,
				id: 'timeconds',
				title: _('Časové podmínky'),
				href: APP_BASE + 'supervisor/timeconds',
			}, {
				id: 'planned-queue-members',
				title: _('Přihlašování'),
				href: APP_BASE + 'supervisor/planned-queue-members',
			}, {
				id: 'ratings',
				title: _('Hodnocení'),
				href: APP_BASE + 'supervisor/ratings',
			}],
		}, {
			className: 'supervisor-content',
			xtype: 'Widgets.CardSwitcher',
			ref: 'cards',
		}], this);
	},

	async applyParams(params) {
		const screen = params.get('screen');
		const screens = {
			'active-calls': 'Supervisor.ActiveCallsScreen',
			'agents': 'Supervisor.AgentsScreen',
			'queues': 'Supervisor.QueuesScreen',
			'callbacks': 'Supervisor.CallbacksScreen',
			'queues-history': 'Supervisor.QueuesHistoryScreen',
			'announce': 'Supervisor.AnnounceScreen',
			'timeconds': 'Supervisor.TimeCondsScreen',
			'planned-queue-members': 'Supervisor.PlannedQueueMembersScreen',
			'ratings': 'Supervisor.CallRatingsScreen',
		};

		this.tabs.setSelected(screen);

		if (screens[screen]) {
			await this.cards.show({
				id: screen,
				xtype: screens[screen],
				params,
			});
		}

		this.cards.prune();

		Application.refreshSubscriptionsFromDOM();
	},
});

// }}}
// {{{ Supervisor.DayStatsBar

GW.define('Supervisor.DayStatsBar', 'GW.Component', {

	expanded: false,

	// PLUGIN: extension point for defining wallboard to show in this component
	getWallboards() {
		return [];
	},
	
	'after:initComponent'() {
		const wallboards = this.getWallboards();
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			socketSubscriptions: ['call_updates'],
			children: [{
				ref: 'wrapEl',
				className: 'day-stats-wrap',
			}, {
				className: 'day-stats-controls',
				children: [{
					ref: 'buttonEl',
					nodeName: 'button',
					className: 'day-stats-btn secondary',
					'on:click': () => {
						this.expanded = !this.expanded;
						localStorage.setItem('day-stats-expanded', this.expanded);
						this.refreshExpandState();
					}
				}, {
					':skip': wallboards.length <= 0,
					nodeName: 'button',
					className: 'secondary',
					textContent: _('Wallboard'),
					'on:click': ev => {
						const showDialog = w => {
							new Main.Dialog({
								title: w.title,
								'after:initComponent'() {
									this.bodyEl.gwCreateChild({
										children: [{
											nodeName: 'button',
											className: 'transparent icon-only small',
											title: _('Kopírovat odkaz'),
											'on:click': async e => {
												await navigator.clipboard.writeText(w.link);
												Application.notify({
													kind: 'success',
													text: _('Odkaz zkopírován do schránky'),
												});
											},
											children: [Utils.useIcon('duplicate')],
										},{
											className: 'link',
											nodeName: 'a',
											target: '_blank',
											textContent: w.link,
											href: w.link,
										}]
									});
								},
							});
						};
						
						if (wallboards.length == 1) {
							showDialog(wallboards[0]);
						} else {
							let popup = new PopupMenu({
								options: wallboards.map(w => ({
									text: w.title,
									handle: () => showDialog(w)
								})),
							});
							PopupManager.show(popup, {
								anchorEl: ev.target.closest('button'),
								forceAxis: 'vertical',
								preferReadingOrder: true,
							});
						}
					}
				}]
			}]
		}, this);
		this.expanded = localStorage.getItem('day-stats-expanded') === 'true';
		this.refreshExpandState();
	},
	
	renderStats(data) {
		if (!this.expanded) return;
		data = data || {};

		this.wrapEl.gwReplaceChildren([{
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Celkem\nhovorů'),
			}, {
				className: 'day-stats-value',
				textContent: data.total_count || '',
			}, {
				title: data.trend,
				className: 'day-stats-icon',
				children: [Utils.useIcon(
					!data.trend || data.trend === 0 ? '' : data.trend > 0 ? 'arrow-up' : data.trend < 0 ? 'arrow-down' : 'error',
					{cls: !data.trend || data.trend === 0 ? 'muted' : data.trend > 0 ? 'error'    : data.trend < 0 ? 'success'    : 'muted'}
				)]
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Dovolané'),
			}, {
				className: 'day-stats-value',
				textContent: data.count_connected || '',
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Nedovolané'),
			}, {
				className: 'day-stats-value',
				textContent: data.count_not_connected || '',
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Průměrně\nv IVR'),
			}, {
				className: 'day-stats-value',
				textContent: Formats.duration(data.avg_early_duration || 0),
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Průměrné\nvyzvánění'),
			}, {
				className: 'day-stats-value',
				textContent: Formats.duration(data.avg_ring_duration || 0),
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Průměrný\nhovor'),
			}, {
				className: 'day-stats-value',
				textContent: Formats.duration(data.avg_duration || 0),
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Celková\ndoba hovorů'),
			}, {
				className: 'day-stats-value',
				textContent: Formats.duration(data.sum_duration || 0)
			}]
		}, {
			className: 'day-stats-box',
			children: [{
				className: 'day-stats-label',
				textContent: _('Service\nlevel'),
			}, (() => {
				let el = document.gwCreateElement({
					className: 'day-stats-value',
				});

				let connected = data.count_connected || 0;
				let not_connected = data.count_not_connected || 0;
				
				if (connected == 0 && not_connected == 0) {
					// no data available - show chart for 0 % = same as all not connected 
					not_connected = 1;
				}

				Charts.makeDoughnut(el, [{
					label: _('Dovolané'),
					value: connected,
					color: 'var(--graph-success-color, green)',
				}, {
					label: _('Nedovolané'),
					value: not_connected,
					color: 'var(--graph-error-color, red)',
				}], Formats.percent(data.service_level_ratio || 0));

				return el;
			})()]
		}]);
	},
	
	refreshExpandState() {
		this.el.classList.toggle('expanded', this.expanded);
		if (this.expanded) {
			this.buttonEl.setAttribute('title', _('Skrýt statistiky skupiny'));
			this.buttonEl.gwReplaceChildren([
				Utils.useIcon('collapse'),
			]);
			this.buttonEl.classList.add('icon-only');
			this.buttonEl.classList.remove('icon-left');
			this.wrapEl.gwHide(false);
			this.renderStats({});
			this.loadData();
		} else {
			this.wrapEl.gwHide(true);
			this.buttonEl.setAttribute('title', '');
			this.buttonEl.gwReplaceChildren([
				Utils.useIcon('expand'),
				_('Statistiky skupiny'),
			]);
			this.buttonEl.classList.add('icon-left');
			this.buttonEl.classList.remove('icon-only');
		}
	},
	
	async loadData() {
		if (!this.expanded) return;
		let signal = Utils.abortAndRetry(this, 'reload');
		const data = await REST.GET('supervisor/day-stats', null, {signal});
		this.renderStats(data);
	},

	onBusMessage(msg) {
		if (msg.type === 'CALL_ENDED' && this.expanded) {
			Utils.dedupeCalls(this, 'reload', 500, () => this.loadData());
		}
	},

});

// }}}
// {{{ Supervisor.chanSpySupportMixin

Supervisor.chanSpySupportMixin = function() {
	return {
		showChanSpyPopup(ev, chanspy_args, user_group_id) {
			let popup = new PopupMenu({
				options: [{
					text: _('Zahájit příposlech'),
					handle: () => this.startChanSpy(chanspy_args, user_group_id),
				}, {
					text: _('Přesměrovat příposlech na číslo'),
					handle: () => this.showChanSpyDialog(chanspy_args, user_group_id),
				}],
			});

			PopupManager.show(popup, {
				anchorEl: ev.target.closest('button'),
				forceAxis: 'vertical',
				preferReadingOrder: true,
			});
		},

		showChanSpyDialog(chanspy_args, user_group_id) {

			let me = this;

			new Main.Dialog({

				title: _('Přesměrovat příposlech'),

				'after:initComponent'() {
					let dlg = this;
					this.bodyEl.gwCreateChild({
						xtype: 'Office.DialerInput',
						'after:initComponent'() {
							this.setButtons([{
								id: 'chanspy',
								icon: 'headphones',
								cls: 'success icon-only',
								title: _('Přesměrovat příposlech'),
							}]);
						},
						'on:select': (c, contact) => {
							me.startChanSpyOriginate(chanspy_args, c.sanitizeNumber(contact.number), user_group_id);
							dlg.close();
						},
						'on:submit': (c, number) => {
							me.startChanSpyOriginate(chanspy_args, number, user_group_id);
							dlg.close();
						},
						'on:buttonclick': (c, btn) => {
							me.startChanSpyOriginate(chanspy_args, c.getNumber(), user_group_id);
							dlg.close();
						},
					});
				},
			});
		},

		initChanSpy() {
			if (this.webphone) {
				return;
			}

			this.webphone = new Office.WebPhone({
				'on:sessionchange': c => {
					/*
					 * When the spy session ends, we disconnect the
					 * spy phone.
					 */
					if (this.spySession && this.spySession.isEnded()) {
						this.stopChanSpy();
						return;
					}

					this.onChanSpyUpdated();
				},
				'on:registrationchange': c => {
					let reg = this.webphone.getRegistrationStatus();
					if (reg.registered || reg.cause) {
						this.webphoneRegistrationCompleter.resolve();
					}
				},
			});
		},

		async startChanSpyOriginate(chanspy_args, target, user_group_id) {
			await REST.POST('supervisor/channel-spy-originate', {...chanspy_args, target}, user_group_id && {
				activeUserGroup: user_group_id,
			});

			Application.notify({
				kind: 'success',
				text: _('Příposlech byl přesměrován'),
				timeout: 3000,
			});
		},

		async startChanSpy(chanspy_args, user_group_id) {
			this.stopChanSpy();

			this.webphoneRegistrationCompleter = Utils.makeCompleter();
			this.webphone.connect();
			this.spyBusy = true;
			this.onChanSpyUpdated();

			try {
				await Promise.any([this.webphoneRegistrationCompleter, Utils.timeoutPromise(3000)]);

				let reg = this.webphone.getRegistrationStatus();
				if (!reg.registered) {
					let msg = reg.cause_message || _('Selhala registrace odposlouchávacího zařízení');

					throw new Error(_('Odposlech není možný.') + ' ' + msg);
				}

				let result = await REST.POST('supervisor/channel-spy', chanspy_args, user_group_id && {
					activeUserGroup: user_group_id,
				});

				this.spySession = this.webphone.call(result.exten);
				this.spyBusy = false;

				this.onChanSpyUpdated();
			} catch(ex) {
				this.stopChanSpy();
				throw ex;
			}
		},

		onChanSpyUpdated() {
			// to be implemented in enclosing component
		},

		stopChanSpy() {
			if (this.spySession) {
				if (!this.spySession.isEnded()) {
					this.spySession.terminate();
				}

				this.spySession = null;
			}

			this.webphone.disconnect();
			this.spyBusy = false;
		},

		async hangupSpyingChannel(channel_args) {
			await REST.POST('supervisor/channel-spy-hangup', channel_args);
			this.onChanSpyUpdated();
		},
	}
}

// }}}
// {{{ Supervisor.ActiveCallsScreen

GW.define('Supervisor.ActiveCallsScreen', 'GW.Component', {

	data: null,

	initComponent() {
		const me = this;
		
		Utils.interval(this, 'duration-update', 1000, () => this.updateDurations());

		function formatContact(number) {
			const contact = me.data && me.data.details && me.data.details.contacts.find(c => c.phone == number);
			const info = contact ? [contact.name, contact.company].filter(v => v).join(', ') : '';

			return [{
				textContent: number,
				className: 'caller-number',
			}, {
				':skip': !info,
				textContent: info,
				className: 'caller-info',
			}];
		}
		
		function formatQueue(number) {
			const queue = me.data && me.data.details && me.data.details.queues.find(q => q.queue == number);

			return [{
				':skip': !queue || !queue.name,
				textContent: queue ? queue.name : '',
				className: 'queue-name',
			}, {
				textContent: number,
				className: 'queue-number',
			}];
		}

		function formatAgent(callee) {
			const user = me.data && me.data.details && me.data.details.users.find(u => u.extension == callee.number);

			return [{
				':skip': !user,
				textContent: user ? user.name : '',
				className: 'callee-name',
			}, {
				':skip': !callee.number,
				textContent: callee.number,
				className: 'callee-number',
			}, {
				':skip': !callee.more,
				children: [{
					nodeName: 'em',
					textContent: _('Více agentů'),
				}],
			}];
		}

		let activeCallsTable = {
			xtype: 'SmartTable',
			extraClass: 'hoverable',
			ref: 'tableActive',

			renderRow(tr, row) {
				tr.classList.toggle('active-chanspy', me.isChanSpyActive(row['channel']));
			},

			getColumns() {
				return [{
					id: 'caller',
					name: _('Volající'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(formatContact(v));
					},
				}, {
					id: 'queue',
					name: _('Fronta'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(formatQueue(v));
					},
				}, {
					id: 'queue_join_ts',
					name: _('Začátek hovoru'),
					format: 'time',
				}, {
					id: 'duration',
					name: _('Délka hovoru'),
					formatCell(td, v, row) {
						td.classList.add('js-duration');
						td.$duration_start = row['start_ts'];
					},
				}, {
					id: 'callee',
					name: _('Agent'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(formatAgent(v));
					},
				}, {
					id: 'ctl',
					name: _('Akce'),
					formatCell: (td, v, row) => {
						me.renderActiveCallButtons(td, row);
					}
				}];
			},
		};

		let waitingCallsTable = {
			xtype: 'SmartTable',
			extraClass: 'hoverable table-waiting',
			ref: 'tableWaiting',
			getColumns() {
				return [{
					id: 'caller',
					name: _('Volající'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(formatContact(v));
					},
				}, {
					id: 'queue',
					name: _('Fronta'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(formatQueue(v));
					},
				}, {
					id: 'queue_join_ts',
					name: _('Vstup do fronty'),
					formatCell(td, v, row) {
						if (row.queue_welcome_ts && !row.queue_join_ts) {
							td.gwReplaceChildren([{
								textContent: Formats.time(row.queue_welcome_ts)
							}, {
								textContent: _('Přehrává úvodní hlášku')
							}]);
						} else {
							td.gwReplaceChildren([{
								textContent: Formats.time(row.queue_join_ts)
							}]);
						}
					},
				}, {
					id: 'duration',
					name: _('Doba ve frontě'),
					formatCell(td, v, row) {
						td.classList.add('js-duration');
						td.$duration_start = (row.queue_welcome_ts && !row.queue_join_ts) ? row.queue_welcome_ts : row.queue_join_ts;
					},
				}, {
					id: 'callee',
					name: _('Agent'),
					formatCell(td, v, row) {
						td.gwReplaceChildren(formatAgent(v));
					},
				}];
			},
		};

		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			socketSubscriptions: ['call_updates'],
			children: [{
				ref: 'filter',
				xtype: 'Widgets.ButtonSwitcher',
				cls: 'button-switcher small light',
				items: [{
					id: 'all',
					title: _('Všechny'),
				}, {
					id: 'active',
					title: _('Aktivní'),
				}, {
					id: 'waiting',
					title: _('Čekající'),
				}],
				'on:beforeselect': (c, i) => {
					Application.route({
						paramsFn: params => {
							params.set('table', i.id);
							return params;
						},
					});
				},
			}, {
				className: 'button-switcher-content',
				children: [{
					ref: 'callsActive',
					children: [{
						className: 'table-title',
						textContent: _('Aktivní hovory'),
					}, activeCallsTable]
				}, {
					ref: 'callsWaiting',
					children: [{
						className: 'table-title',
						textContent: _('Čekající hovory'),
					}, waitingCallsTable],
				}],
			}]
		}, this);

		this.initChanSpy();
	},

	releaseComponent() {
		this.stopChanSpy();
	},

	renderActiveCallButtons(td, call) {
		if (this.isChanSpyActive(call.channel)) {
			td.gwCreateChild({
				nodeName: 'button',
				className: 'small secondary static icon-only',
				title: _('Příposlech aktivní'),
				children: [{
					nodeName: 'img',
					src: APP_BASE + 'img/dialing-animation.gif',
					className: 'icon',
				}],
			});

			td.gwCreateChild({
				nodeName: 'button',
				className: 'small secondary icon-only',
				title: _('Opustit příposlech'),
				children: [Utils.useIcon('logout')],
				'on:click': () => this.hangupSpyingChannel({channel: call.channel}),
			});
		} 
		td.gwCreateChild({
			nodeName: 'button',
			className: 'small secondary icon-only select-input',
			title: _('Zahájit příposlech'),
			children: [Utils.useIcon('headphones')],
			disabled: !!this.spyBusy,
			'on:click': e => this.showChanSpyPopup(e, {channel: call.channel}),
		});

		td.gwCreateChild({
			nodeName: 'button',
			className: 'small error icon-only',
			title: _('Zavěsit'),
			children: [Utils.useIcon('phone-hangup')],
			'on:click': () => this.hangup(call.channel),
		});
	},

	hangup(channel) {
		let me = this;

		new Main.ConfirmDialog({
			confirmCls: 'error',
			title: _('Opravdu si přejete hovor zavěsit?'),

			async onSave() {
				await REST.POST('supervisor/hangup-call', {channel});
				me.reload();
			},
		});
	},

	updateDurations() {
		for (let td of this.el.querySelectorAll('.js-duration')) {
			if (td.$duration_start) {
				td.textContent = Utils.getElapsedTime(td.$duration_start);
			}
		}
	},

	updateTables(which = 'both') {
		if (!this.data) {
			return;
		}

		if (which === 'both' || which === 'active') {
			this.tableActive.setData(this.data.calls.filter(c => c.start_ts));
		}

		if (which === 'both' || which === 'waiting') {
			this.tableWaiting.setData(this.data.calls.filter(c => !c.start_ts));
		}

		this.updateDurations();
	},

	...Supervisor.chanSpySupportMixin(),

	isChanSpyActive(channel) {
		return this.data && this.data.chanspies.some(chanspy => chanspy.spyee_channel == channel);
	},

	onChanSpyUpdated() {
		this.updateTables('active');
	},

	async reload() {
		let signal = Utils.abortAndRetry(this, 'reload');

		this.data = await REST.GET('all-queue-calls', null, {signal});
		this.updateTables();
	},

	async applyParams(params) {
		const table = params.get('table') || 'all';

		this.filter.setSelected(table);
		
		this.callsActive.className = table === 'active' || table === 'all' ? 'visible' : 'hidden';
		this.callsWaiting.className = table === 'waiting' || table === 'all' ? 'visible' : 'hidden';
		
		await this.reload();
	},

	onBusMessage(msg) {
		if (msg.type === 'CALL_CHANGED') {
			Utils.dedupeCalls(this, 'reload', 500, () => this.reload());
		}
	},
});

// }}}
// {{{ Supervisor.autoHideMixin

Supervisor.autoHideMixin = function() {
	const containerSelector = '.queue-list';

	function getExpander(ct) {
		return ct.parentNode.querySelector('.expander');
	}

	let state = {};

	return {
		renderAutoHideButton(storageKey) {
			return {
				$storageKey: storageKey,
				nodeName: 'button',
				className: 'transparent expander hidden',
				children: [{
					textContent: _('Více'),
					className: 'label',
				}, {
					className: 'count',
				}],
				'on:click': ev => {
					let expander = ev.currentTarget;
					let expandContainer = expander.closest(containerSelector) || expander.parentNode.querySelector(containerSelector);
					let expandResult = expandContainer.classList.toggle('expanded');

					expander.querySelector('.label').textContent = expandResult ? _('Méně') : _('Více');
					expander.querySelector('.count').style.display = expandResult ? 'none' : null;

					this.updateAutoHide([expandContainer]);

					state[storageKey] = expandResult;
				},
			};
		},

		restoreAutoHide(el) {
			let expander = getExpander(el);
			let expandResult = state[expander.$storageKey];

			el.classList.toggle('expanded', !!expandResult);

			expander.querySelector('.label').textContent = expandResult ? _('Méně') : _('Více');
			expander.querySelector('.count').style.display = expandResult ? 'none' : null;
		},

		updateAutoHide(els) {
			for (let el of els) {
				let expander = getExpander(el);

				if (el.clientHeight < el.scrollHeight) {
					expander.classList.remove('hidden');
					let expanderCount = expander.querySelector('.count');
					let agentsElements = el.querySelectorAll('.agent, .queue');
					let containerPos = el.getBoundingClientRect();

					let visibleItems = 0;
					for (let agentEl of agentsElements) {
						let agentPos = agentEl.getBoundingClientRect();

						if (agentPos.top - containerPos.top + agentPos.height <= el.clientHeight) {
							visibleItems += 1;
						}
					}

					let hiddenItems = agentsElements.length - visibleItems;
					expanderCount.textContent = ` (${hiddenItems})`;
				} else {
					if (!el.classList.contains('expanded')) {
						expander.classList.add('hidden');
					}
				}
			}
		},

		initAutoHide() {
			this.finiAutoHide();

			let updateOverflowDebounced = els => {
				clearTimeout(this.updateOverflowTimer);

				this.updateOverflowTimer = setTimeout(() => this.updateAutoHide(els), 250);
			};

			this.resizeObserver = new ResizeObserver(entries => {
				updateOverflowDebounced(entries.map(entry => entry.target));
			});

			for (let el of this.el.querySelectorAll(containerSelector)) {
				this.resizeObserver.observe(el);
				this.updateAutoHide([el]);
				this.restoreAutoHide(el);
			}
		},

		finiAutoHide() {
			if (this.resizeObserver) {
				clearTimeout(this.updateOverflowTimer);
				this.updateOverflowTimer = null;

				this.resizeObserver.disconnect();
				this.resizeObserver = null;
			}
		},
	};
};

// }}}
// {{{ Supervisor.collapseToggleMixin

/*
 * Usage:
 *
 * - call initCollapseToggle() from initComponent of extended class
 * - call collapseToggleRefresh() after reloading the list of collapsible items
 * - identify collapse buttons with `collapseAllButtonSelector` and `collapseItemButonSelector`
 */
Supervisor.collapseToggleMixin = function({
	storageKey,
	itemContainerSelector,
	collapseAllButtonSelector = '.collapse-toggle-button',
	collapseItemButonSelector = '.collapse-button',
}) {
	return {
		initCollapseToggle() {
			let me = this;
			let user = Application.session.user.id;
			let collapsedItems = new Set(Utils.getLocalState({user, key: storageKey}, []));

			function save() {
				Utils.setLocalState({user, key: storageKey}, [...collapsedItems]);
			}

			function setCollapsed(id, collapsed) {
				collapsedItems[collapsed ? 'add' : 'delete'](id);
				save();
			}

			function isExpandedAll() {
				return !me.el.querySelector('.collapsed' + itemContainerSelector);
			}

			function collapseAll() {
				collapsedItems = new Set();

				me.el.querySelectorAll(itemContainerSelector).forEach(el => {
					el.classList.add('collapsed');
					collapsedItems.add(el.dataset.id);
				});

				save();
			}

			function expandAll() {
				collapsedItems = new Set();

				me.el.querySelectorAll(itemContainerSelector).forEach(el => {
					el.classList.remove('collapsed');
				});

				save();
			}

			function updateCollapseAllButton() {
				let allExpanded = isExpandedAll();

				for (let el of me.el.querySelectorAll(collapseAllButtonSelector)) {
					el.gwReplaceChildren(allExpanded
						? [Utils.useIcon('collapse'), _('Sbalit vše')]
						: [Utils.useIcon('expand'), _('Rozbalit vše')]
					);
				}
			}

			/*
			 * Should be called after the using componenet reloads
			 * the list of collapsible items.
			 */
			this.collapseToggleRefresh = function() {
				this.el.querySelectorAll(itemContainerSelector).forEach(el => {
					el.classList.toggle('collapsed', collapsedItems.has(el.dataset.id));
				});

				updateCollapseAllButton();
			};

			this.el.addEventListener('click', ev => {
				if (ev.target.closest(collapseAllButtonSelector)) {
					if (isExpandedAll()) {
						collapseAll();
					} else {
						expandAll();
					}

					updateCollapseAllButton();
				}

				if (ev.target.closest(collapseItemButonSelector)) {
					let itemCt = ev.target.closest(itemContainerSelector);

					setCollapsed(itemCt.dataset.id, itemCt.classList.toggle('collapsed'));
					updateCollapseAllButton();
				}
			}, true);
		},
	};
};

// }}}
// {{{ Supervisor.AgentsMixin

// common functions for AgentsRow and AgentsTable components
Supervisor.agentsMixin = () => ({

	// require this.pauseTypes to be set
	async pauseWithPauseTypes(anchorEl, extension, group_id, pauseTypes) {
		const types = (pauseTypes || this.pauseTypes || []);
		if (types.length > 0) {
			let popup = new PopupMenu({
				options: types.map(pause_type => ({
					text: pause_type.name,
					async handle() {
						await REST.POST('queues/all/exten/' + encodeURIComponent(extension) + '/pause', {
							pause_type: pause_type.id,
						}, {
							activeUserGroup: group_id,
						});
					},
				})),
			});
			PopupManager.show(popup, {
				anchorEl,
				forceAxis: 'vertical',
				preferReadingOrder: true,
			});
		} else {
			// no pause types available, do not show popup, just pause queue
			await REST.POST('queues/all/exten/' + encodeURIComponent(extension) + '/pause', undefined, {
				activeUserGroup: group_id,
			});
		}
	},

});

// }}}
// {{{ Supervisor.AgentsTable

GW.define('Supervisor.AgentsTable', 'GW.Component', {

	queueNames: {},
	pauseTypes: null,

	initComponent() {
		
		let me = this;
		
		let renderTable = (group_id) => ({
			xtype: 'SmartTable',
			ref: 'table',
			group_id,
			emptyText: group_id ? _('V této skupině nejsou žádní agenti') : _('Nejsou k dispozici žádní agenti'),
			getColumns()  {
				const hidden = new Set((localStorage.getItem('supervisor-agents-table-columns-hidden') || '').split(','));
				return me.getColumns(this.rows, group_id)
					.filter(col => !hidden.has(col.id));
			},
			'after:setData'() {
				me.updateQueueNames(this.el);
			},
		});
		
		let children = [];
		if (Application.getActiveUserGroup().id !== 'all') {
			// user has selected some group
			children = [renderTable()];
		} else {
			// user has selected all groups
			children = Application.session.user.groups.map(group => ({
				className: 'agents-table-group',
				children: [{
					nodeName: 'h4',
					className: 'agents-table-group-title',
					textContent: group.name,
				}, renderTable(group.id)]
			}));
		}

		this.el = document.gwCreateElement({
			className: 'button-switcher-content',
			children
		}, this);

		Utils.interval(this, 'timers-update', 1000, () => this.updateTimers());

		this.initChanSpy();
	},

	...Supervisor.agentsMixin(),

	getColumns(data, group_id) {

		const statusButtonRenderer = getter => (td, v, row) => {
			const value = getter ? getter(row) : v;
			td.gwReplaceChildren([{
				className: 'button xs icon-left static grey',
				children: [
					Utils.useIcon('dot', {cls: value ? 'success' : 'muted'}),
					{textContent: value ? _('Online') : _('Offline'),}
				],
			}]);
		};

		const onClickShowCallsDialogRenderer = (column, title) => (td, v, row) => {
			td.gwReplaceChildren([{
				className: 'show-calls-cell',
				textContent: v,
				'on:click': () =>
					this.showCallsDialog(_('Seznam hovorů') + ' - ' + title, {
						user_id: row.user_id,
						column
					}),
			}]);
		};

		const columnWithCallsDialog = (id, name) => ({
			id,
			name,
			formatCell: onClickShowCallsDialogRenderer(id, name),
		});

		const user_queues = [...new Set((data || this.data || [])
			.flatMap(user => user.queues.filter(q => q.kind !== 'personal'))
			.map(q => {
				this.queueNames[q.queue] = q.name;
				return q.queue;
			})
		)].sort();
		
		const user_pause_types = (this.pauseTypes || [])
			.filter(pauseType => !group_id || pauseType.group_ids.includes(group_id));

		const getSubscribedQueues = user => user.queues.filter(q => q.state === 'subscribed' || q.state === 'paused');

		const renderDurationWithFixedWidth = (td, v, row) => {
			td.classList.add('duration-width');
			td.textContent = Formats.duration(v);
		};

		const renderShortDurationWithFixedWidth = (td, v, row) => {
			td.classList.add('duration-short-width');
			td.textContent = Formats.duration_short(v);
		};

		const durationWithLiveUpdateRenderer = (get_data, format = 'duration') => (td, v, row) => {
			const user = row;

			const {is_active, duration = v} = get_data(user);

			if (format === 'duration') {
				renderDurationWithFixedWidth(td, duration, row);
			}
			if (format === 'duration_short') {
				renderShortDurationWithFixedWidth(td, duration, row);
			}
			td.$format = format;
			if (is_active) {
				td.classList.add('since-last-update-timer');
				td.$lastUpdateTs = Date.now();
				td.$lastUpdateDuration = duration;
			}
		};

		return [{
			id: 'name',
			name: _('Jméno'),
		}, {
			id: 'extension',
			name: _('Linka'),
		}, {
			id: 'session_exists',
			name: _('AP'),
			formatCell: statusButtonRenderer()
		}, {
			id: 'hw_online',
			name: _("HW"),
			formatCell: statusButtonRenderer(user => user.devices && user.devices.some(d => d.kind !== 'webrtc' && d.reachable))
		}, {
			id: 'followme',
			name: _('Ext.'),
			formatCell: statusButtonRenderer()
		}, {
			id: 'state',
			name: _('Stav'),
			formatCell: (td, v, row) => {
				td.gwReplaceChildren([this.renderStatusButton(row)]);
			},
		}, {
			id: 'chanspy',
			name: _('Příposlech'),
			formatCell: (td, v, row) => {
				this.addChanSpyButtons(td, row);
			},
		}, ...user_queues.map(queue => ({
			id: 'queue_' + queue,
			name: {
				className: 'table-header-queue',
				'attr:data-queue': queue,
				'on:click': (e) => this.toggleQueueNames(),
			},
			columnName: queue,
			formatCell: (td, v, row) => {
				const user = row;
				td.gwReplaceChildren([this.renderQueue(user, user.queues.find(q => q.queue == queue))]);
			},
		})), {
			...columnWithCallsDialog('in_count', _('Celkem In')),
		}, {
			...columnWithCallsDialog('in_count_connected', _('Dovolaných In')),
		}, {
			...columnWithCallsDialog('in_count_not_connected', _('Nedovolaných In')),
		}, {
			...columnWithCallsDialog('in_count_ring', _('Zvonění In')),
		}, {
			id: 'in_service_level_ratio',
			name: _('Úroveň In'),
			format: 'percent',
		}, {
			...columnWithCallsDialog('out_count', _('Celkem Out')),
		}, {
			...columnWithCallsDialog('out_count_connected', _('Dovolaných Out')),
		}, {
			...columnWithCallsDialog('out_count_not_connected', _('Nedovolaných Out')),
		}, {
			id: 'out_service_level_ratio',
			name: _('Úroveň Out'),
			format: 'percent',
		}, {
			id: 'in_avg_ring_duration',
			name: _('⌀ Zvonění In'),
			formatCell: renderDurationWithFixedWidth,
		}, {
			id: 'in_avg_duration',
			name: _('⌀ Hovor In'),
			formatCell: renderDurationWithFixedWidth,
		}, {
			id: 'out_avg_duration',
			name: _('⌀ Hovor Out'),
			formatCell: renderDurationWithFixedWidth,
		}, {
			id: 'login_first_ts',
			name: _('Příchod'),
			format: 'time_short',
		}, {
			id: 'login_last_ts',
			name: _('Odchod'),
			format: 'time_short',
		}, {
			id: 'sum_login',
			name: _('Celkem'),
			formatCell: durationWithLiveUpdateRenderer(user => ({
				is_active: user.session_exists,
			}), 'duration_short'),
		}, {
			id: 'sum_calls_in',
			name: _('V hovoru In'),
			formatCell: renderShortDurationWithFixedWidth,
		}, {
			id: 'sum_calls_out',
			name: _('V hovoru Out'),
			formatCell: renderShortDurationWithFixedWidth,
		}, {
			id: 'sum_calls',
			name: _('V hovoru celkem'),
			formatCell: renderShortDurationWithFixedWidth,
		}, ...user_queues.map(queue => ({
			id: 'sum_in_queue_' + queue,
			name: _('Ve frontě {queue}').replace('{queue}', queue),
			formatCell: durationWithLiveUpdateRenderer(user => ({
				is_active: user.session_exists && getSubscribedQueues(user).some(q => q.queue == queue),
				duration: user.sum_in_queues
					.filter(s => s.queue == queue)
					.map(s => s.sum)[0],
			}), 'duration_short'),
		})), {
			id: 'sum_in_queue',
			name: _('Ve frontách celkem'),
			formatCell: durationWithLiveUpdateRenderer(user => ({
				is_active: user.session_exists && getSubscribedQueues(user).length > 0,
			}), 'duration_short'),
		}, {
			id: 'sum_no_queue',
			name: _('Bez fronty'),
			formatCell: durationWithLiveUpdateRenderer(user => ({
				is_active: user.session_exists && getSubscribedQueues(user).length == 0,
			}), 'duration_short')
		}, ...user_pause_types.map(pauseType => ({
			id: 'sum_pause_' + pauseType.id,
			name: _('V pauze {name}').replace('{name}', pauseType.name),
			formatCell: durationWithLiveUpdateRenderer(user => ({
				is_active: user.pause && user.pause.pause_type && user.pause.pause_type.id == pauseType.id,
				duration: user.sum_pauses
					.filter(s => s.pause_type_id == pauseType.id)
					.map(s => s.sum)[0],
			}), 'duration_short'),
		})), {
			id: 'sum_pause_wrapup',
			name: _('V Autopauze'),
			formatCell: durationWithLiveUpdateRenderer(user => ({
				is_active: user.pause && user.pause.type === 'wrapup',
			}), 'duration_short'),
		}, {
			id: 'sum_pause',
			name: _('Celkem v pauze'),
			formatCell: durationWithLiveUpdateRenderer(user => ({
				is_active: user.pause,
			}), 'duration_short'),
		}, {
			id: 'acitivity',
			name: _('Report aktivit'),
			formatCell: (td, v, row) => {
				td.gwReplaceChildren([{
					nodeName: 'button',
					className: 'small secondary',
					textContent: _('Zobrazit aktivitu'),
					'on:click': () => this.showUserActivity(row.user_id),
				}])
			}
		}];
	},

	renderColumnsSettingsButton() {
		const me = this;
		return {
			nodeName: 'button',
			type: 'button',
			className: 'secondary small icon-only',
			children: [Utils.useIcon('settings')],
			'on:click': () => {
				let hidden = new Set((localStorage.getItem('supervisor-agents-table-columns-hidden') || '').split(','));
				new Main.ListSelectDialog({
					title: _('Zobrazení sloupců'),
					selectAllText: _('Zobrazit vše'),
					unselectAllText: _('Skrýt vše'),
					reorderAllowed: false,

					items: me.getColumns().map(c => ({
						id: c.id,
						title: c.columnName || c.name,
						selected: !hidden.has(c.id),
					})),

					onSave({selected}) {
						let hide = new Set(this.items.map(c => c.id));
						for (let id of selected) {
							hide.delete(id);
						}

						localStorage.setItem('supervisor-agents-table-columns-hidden', [...hide].join(','));

						me.table.refresh();
					},
				});
			},
		}
	},

	renderExcelExportButton() {
		return {
			nodeName: 'button',
			type: 'button',
			className: 'secondary small',
			textContent: _('Exportovat XLSX'),
			'on:click': () => {
				let params = new URLSearchParams();
				let group = Application.getActiveUserGroup();
				if (group) {
					params.set('active_user_group', group.id);
				}
				location.href = API_BASE + 'supervisor/queue-agents/table/export/xlsx?' + params.toString();
			},
		}
	},

	async showCallsDialog(title, data) {
		const calls = await REST.POST('supervisor/queue-agents/calls', data);
		new Main.Dialog({
			title,
			'after:initComponent'() {
				this.bodyEl.gwCreateChild({
					xtype: 'SmartTable',
					extraClass: 'cdr-smart-table',
					getColumns: () => [{
						id: 'direction',
						name: _('Směr'),
						formatCell(td, v, row) {
							td.gwCreateChild(Office.renderDirectionIcon(row, true));
							td.gwCreateChild(Formats.call_direction(v));
						},
					}, {
						id: 'begin_ts',
						format: 'datetime',
						name: _('Začátek hovoru'),
					}, {
						id: 'queue',
						name: _('Vstupní fronta'),
					}, {
						id: 'caller',
						name: _('Volající'),
					}, {
						id: 'caller_name',
						name: _('Jméno'),
						fullName: _('Jméno volajícího'),
					}, {
						id: 'callee',
						name: _('Volaný'),
					}, {
						id: 'callee_name',
						name: _('Jméno'),
						fullName: _('Jméno volaného'),
					}],
					ref: 'table',
				}, this);
				this.table.setData(calls);
			},
		});
	},

	async showUserActivity(user_id) {
		const data = await REST.POST('supervisor/user-activity', {
			user_id,
			time_since: Utils.formatDateIso(new Date()),
		});
		new Main.Dialog({
			title: _('Report aktivit'),

			'after:initComponent'() {
				this.bodyEl.gwCreateChild({
					xtype: 'SmartTable',
					getColumns: () => data.columns,
					ref: 'table',
				}, this);
				this.table.setData(data.rows);
			},
		});
	},

	updateQueueNames(el) {
		el.querySelectorAll('.table-header-queue[data-queue]').forEach(el => {
			el.textContent = this.showQueueNames ? (this.queueNames[el.dataset.queue] || el.dataset.queue) : el.dataset.queue;
		});
	},

	toggleQueueNames() {
		this.showQueueNames = !this.showQueueNames;
		this.updateQueueNames(this.el);
	},

	renderQueue(user, queue) {
		if (!queue) {
			return null;
		}
		return {
			nodeName: 'button',
			className: 'queue queue-control-item ' + ((!user.extension || !queue.visible_for_agent) ? 'disabled' : ''),
			'attr:data-status': (user && user.active_calls_queues && user.active_calls_queues.includes(queue.queue)) ? 'in-queue-call' : queue.state, // unsubscribed subscribed paused
			'attr:data-static': queue.static_membership ? '1' : '0',
			'attr:data-type': queue.kind,
			'attr:data-no-device': !user.is_free ? '1' : '0',
			title: queue.static_membership ? 
				_c('Přihlášen trvale', 'queue') : (!queue.visible_for_agent ? _('Agent frontu nemá k dispozici') : undefined),			
			children: [{
				className: 'status',
			}, {
				':skip': !queue.penalty,
				className: 'info',
				textContent: 'P' + queue.penalty,
			}],
			'on:click': async () => {
				if (queue.static_membership || !user.extension || !queue.visible_for_agent) {
					return;
				}
				
				let opts = {
					activeUserGroup: user.group_id,
				}

				if (queue.state === 'unsubscribed') {
					await REST.POST('queues/' + encodeURIComponent(queue.queue) + '/exten/' + encodeURIComponent(user.extension) + '/join', null, opts);
				} else {
					await REST.POST('queues/' + encodeURIComponent(queue.queue) + '/exten/' + encodeURIComponent(user.extension) + '/leave', null, opts);
				}
			},
		};
	},

	...Supervisor.chanSpySupportMixin(),

	onChanSpyUpdated() {
		for (let table of this.el.querySelectorAll('.smart-table')) {
			table.gwComponent.refresh();
		}
	},

	addChanSpyButtons(td, user) {
		if (!user.extension) {
			return;
		}
		if (user.chanspies.length) {
			td.gwCreateChild({
				nodeName: 'button',
				className: 'small secondary static icon-only',
				title: _('Příposlech aktivní'),
				children: [{
					nodeName: 'img',
					src: APP_BASE + 'img/dialing-animation.gif',
					className: 'icon',
				}],
			});

			td.gwCreateChild({
				nodeName: 'button',
				className: 'small secondary icon-only',
				title: _('Opustit příposlech'),
				children: [Utils.useIcon('logout')],
				'on:click': () => this.hangupSpyingChannel({exten: user.extension}),
			});
		}
		td.gwCreateChild({
			nodeName: 'button',
			className: 'small secondary icon-only select-input',
			title: _('Zahájit příposlech'),
			children: [Utils.useIcon('headphones')],
			disabled: !!this.spyBusy,
			'on:click': e => this.showChanSpyPopup(e, {exten: user.extension}, user.group_id),
		});
	},

	renderStatusButton(user) {
		if (user.in_call) {
			return {
				className: 'status-container button xs icon-left static primary ' + (!user.in_call_connected && 'primary-shadow'),
				children: [
					Utils.useIcon('phone'),
					{
						textContent: user.in_call_connected ? _('Hovoří') : _('Vyzvání')
					}, {
						$dialTs: user.active_call_start_ts || user.active_call_ring_ts || user.active_call_dial_ts,
						className: 'active-call-dial-ts-timer',
					}
				]
			}
		}
		if (user.pause) {
			return {
				nodeName: 'button',
				className: `status-container button xs icon-left warning`,
				'attr:data-state': 'paused',
				children: [
					Utils.useIcon( 'play'),
					{
						title: (user.pause.pause_type ? user.pause.pause_type.name : null),
						children: [{
							textContent: (user.pause.pause_type && user.pause.pause_type.name) || _('Pauza'),
							className: 'pause-name',
						}, {
							$pause: user.pause,
							className: 'pause-timer',
						}]
					}
				],
				'on:click': async ev => {
					ev.preventDefault();
					await REST.POST('queues/all/exten/' + encodeURIComponent(user.extension) + '/unpause', null, {
						activeUserGroup: user.group_id,
					});
				},
			}
		}
		const user_in_queues = user => user.queues.some(q => q.state === 'subscribed' || q.state === 'paused');
		
		if (user_in_queues(user) && user.is_free) {
			const pauseTypes = (this.pauseTypes || []).filter(pauseType => pauseType.group_ids.includes(user.group_id));
			return {
				nodeName: 'button',
				className: `status-container button xs icon-left grey ${pauseTypes.length > 0 ? 'with-pause-types' : ''}`,
				'attr:data-state': 'not-paused',
				children: [Utils.useIcon('checkmarkcircle', {cls: 'success'}), {textContent: _('Volný')}],
				'on:click': async ev => {
					ev.preventDefault();
					await this.pauseWithPauseTypes(ev.target.closest('button'), user.extension, user.group_id, pauseTypes);
				},
			};
		}
		// user is not available, check if it is available in any other groups
		if (this.data.some(u => u.user_id == user.user_id && u.group_id != user.group_id && user_in_queues(u))) {
			return {
				className: 'status-container button xs icon-left static grey',
				children: [ Utils.useIcon('error'), {textContent: _('Přihlášen v jiné skupině')} ],
			};
		}
		return {
			className: 'status-container button xs icon-left static grey',
			children: [ Utils.useIcon('error'), {textContent: _('Nedostupný')} ],
		};
	},

	saveScrollState() {
		return {
			left: this.el.scrollLeft,
			top: this.el.scrollTop,
		};
	},

	restoreScrollState(state) {
		this.el.scrollLeft = state.left;
		this.el.scrollTop = state.top;
	},

	setData(data) {
		this.data = data;
		for (let table of this.el.querySelectorAll('.smart-table')) {
			const group_id = table.gwComponent.group_id;
			if (group_id) {
				table.gwComponent.setData(this.data.filter(r => r.group_id == group_id));
			} else {
				table.gwComponent.setData(this.data);
			}
		}
	},

	updateTimers() { // TODO add missing timers
		if (!this.el) {
			return;
		}

		const pause_time = (pause) => {
			if (!pause || !pause.start_ts) {
				return '';
			}
			const duration = pause.end_ts ? (pause.end_ts - Date.now()) : (Date.now() - pause.start_ts);
			return Formats.duration_unpadded(Math.max(0, duration));
		};

		this.el.querySelectorAll('.pause-timer').forEach(el => {
			el.textContent = ' ' + pause_time(el.$pause);
		});

		this.el.querySelectorAll('.active-call-dial-ts-timer').forEach(el => {
			el.textContent = ' ' + Formats.duration(Date.now() - el.$dialTs);
		});

		this.el.querySelectorAll('.since-last-update-timer').forEach(el => {
			el.textContent = Formats[el.$format](Date.now() - el.$lastUpdateTs + +el.$lastUpdateDuration);
		});
	},

});

// }}}
// {{{ Supervisor.AgentsRows

GW.define('Supervisor.AgentsRows', 'GW.Component', {

	pauseTypes: null,

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'button-switcher-content',
			ref: 'dataEl',
		}, this);

		this.initCollapseToggle();

		Utils.interval(this, 'timers-update', 1000, () => this.updateTimers());
	},

	...Supervisor.autoHideMixin(),

	...Supervisor.collapseToggleMixin({
		storageKey: 'supervisor-agents-screen-collapsed',
		itemContainerSelector: '.agent-container',
	}),

	...Supervisor.agentsMixin(),

	'before:destroy'() {
		this.finiAutoHide();
	},

	updateTimers() {
		if (!this.el) {
			return;
		}

		const pause_time = (pause) => {
			if (!pause || !pause.start_ts) {
				return '';
			}
			const duration = pause.end_ts ? (pause.end_ts - Date.now()) : (Date.now() - pause.start_ts);
			return Formats.duration_unpadded(Math.max(0, duration));
		};
		this.el.querySelectorAll('.pause-timer').forEach(el => {
			el.textContent = ' ' + pause_time(el.$pause);
		});

		this.el.querySelectorAll('.active-call-dial-ts-timer').forEach(el => {
			el.textContent = ' ' + Formats.duration(Date.now() - el.$dialTs);
		});
	},

	renderAgentStatus(user) {
		const subcribedQueues = user.queues.filter(q => q.state === 'subscribed' || q.state === 'paused');
		const withPauseTypes = this.pauseTypes && this.pauseTypes.length > 0;

		const webrtc_reachable = user.devices && user.devices.some(d => d.kind === 'webrtc' && d.reachable);
		const phone_reachable  = user.devices && user.devices.some(d => d.kind !== 'webrtc' && d.reachable);

		return {
			className: 'agent-status',
			children: [{
				className: 'agent-title',
				children: [{
					textContent: user.name,
					title: user.name,
				}, {
					className: 'agent-extension-select',
					xtype: 'Main.ExtensionSelector',
					userId: user.user_id,
					getCurrentExtension: () => Main.ExtensionSelector.getSelectedExtensionOfUser(user),
				}, {
					':skip': user.user_groups.length == 0,
					cls: 'small',
					xtype: 'SelectField',
					popupAutoWidth: false,
					disabled: user.user_groups.length <= 1 || user.in_call,
					title: user.in_call ? _('Nelze změnit skupinu během probíhajícího hovoru') : undefined,
					options: user.user_groups.map(g => ({
						value: g.group_id,
						text: g.group_name,
					})),
					value: user.dialer_group_id,
					'on:change': async c => {
						try {
							await REST.PUT(`users/${user.user_id}/dialer-group`, {group_id: c.getValue()});
						} catch (e) {
							// revert value if group change failed
							c.setValue(user.dialer_group_id);
							throw e;
						}
					},
					'wrap:refreshInput'(fn) {
						fn();
						if (this.option && this.option.value != Application.getActiveUserGroup().id) {
							this.input.insertBefore(
								document.gwCreateElement({
									className: 'status-container button xs icon-only static error',
									title: _('Uživatel je v jiné skupině než vy'),
									children: [Utils.useIcon('warningsign')],
								}), 
								this.input.firstChild
							);
						}
					},
				}]
			}, {
				className: 'status-container button xs icon-left static grey',
				children: [
					Utils.useIcon('dot', {cls: webrtc_reachable ? 'success' : 'muted'}),
					{textContent: webrtc_reachable ? _('Online') : _('Offline'),}
				],
			}, {
				className: 'status-container button xs icon-left static grey',
				children: [
					Utils.useIcon('dot', {cls: phone_reachable ? 'success' : 'muted'}),
					Utils.useIcon('telephone',  {cls: phone_reachable ? '' : 'muted'}), // TODO test
				],
			}, {
				className: 'status-container button xs icon-left static grey',
				children: [
					Utils.useIcon('queue', {cls: subcribedQueues.length > 0 ? 'success' : 'muted'}),
					{
						textContent: subcribedQueues.length + '/' + user.queues.length,
					}
				],
				title: subcribedQueues.length > 0 ?
					(subcribedQueues.length > 1 ?
						_n(subcribedQueues.length, 'Agent je přihlášen ve {n} frontách') :
						_('Agent je přihlášen v jedné frontě')) :
					_('Agent není přihlášen v žádné frontě')
			}, {
				':skip': !(subcribedQueues.length > 0 && !phone_reachable && !webrtc_reachable && !user.followme),
				className: 'status-container button xs icon-only static error',
				children: [Utils.useIcon('warningsign')],
				title: _('Agent je přihlášen ve frontách, ale nemá registrované žádné zařízení!'),
			}, {
				':skip': !(subcribedQueues.length === 0 && (phone_reachable || webrtc_reachable || user.followme)),
				className: 'status-container button xs icon-only static error-secondary',
				children: [Utils.useIcon('warningsign')],
				title: _('Agent není přihlášen ani v jedné frontě!'),
			}, {
				':skip': !(subcribedQueues.length === 0 && !phone_reachable && !webrtc_reachable && !user.followme),
				className: 'status-container button xs icon-left static grey',
				children: [ Utils.useIcon('error'), {textContent: _('Nedostupný')} ],
			}, {
				':skip': !(subcribedQueues.length > 0 && (webrtc_reachable || phone_reachable) && !user.in_call && !user.pause && user.is_free),
				className: 'status-container button xs icon-left static grey',
				children: [ Utils.useIcon('checkmarkcircle', {cls: 'success'}), {textContent: _('Volný')} ],
				title: _('Aktuálně neprobíhá žádný hovor'),
			}, {
				':skip': !(!user.in_call && !user.pause && user.followme),
				className: 'status-container button xs icon-left static grey',
				children: [ Utils.useIcon('checkmarkcircle'), {textContent: _('Externí linka')} ],
				title: _('Agent je přihlášen na externí lince'),
			}, {
				':skip': !(user.in_call),
				className: 'status-container button xs icon-left static primary ' + (!user.in_call_connected && 'primary-shadow'),
				children: [
					Utils.useIcon('phone'),
					{
						textContent: user.in_call_connected ? _('Hovoří') : _('Vyzvání')
					}, {
						$dialTs: user.active_call_start_ts || user.active_call_ring_ts || user.active_call_dial_ts,
						className: 'active-call-dial-ts-timer',
					}
				],
			}, {
				className: 'controls',
				children: [{
					nodeName: 'button',
					'attr:data-state': user.pause ? 'paused' : 'not-paused',
					className: `status-container button xs icon-left ${user.pause ? 'warning' : 'grey'} ${withPauseTypes ? 'with-pause-types' : ''}`,
					disabled: !user.queues.some(q => q.state === 'subscribed' || q.state === 'paused'),
					children: [
						Utils.useIcon( user.pause ? 'play' : 'pause', {cls: user.pause ? undefined : 'warning'}),
						(user.pause ? {
							title: (user.pause.pause_type ? user.pause.pause_type.name : null),
							children: [{
								textContent: _('Zrušit pauzu'),
							}, {
								':skip': !user.pause.pause_type,
								textContent: (user.pause.pause_type ? ' (' + user.pause.pause_type.name + ')' : ''),
								className: 'pause-name',
							}, {
								$pause: user.pause,
								className: 'pause-timer',
							}]
						} : {
							textContent: _('Zapnout pauzu')
						}),
					],
					'on:click': async ev => {
						ev.preventDefault();

						if (!user.extension) {
							return;
						}

						if (user.pause) {
							await REST.POST('queues/all/exten/' + encodeURIComponent(user.extension) + '/unpause');
						} else {
							await this.pauseWithPauseTypes(ev.target.closest('button'), user.extension);
						}
					},
				}, {
					nodeName: 'button',
					':skip': !user.extension,
					className: 'more transparent xs icon-only status-container button',
					children: [Utils.useIcon('vdots', {cls: 'xs'})],
					'on:click': ev => {
						ev.preventDefault();
						let opts = {
							activeUserGroup: user.group_id,
						}
						let popup = new PopupMenu({
							options: [{
								iconName: 'login',
								text: _('Přihlásit do všech front'),
								async handle() {
									await REST.POST('queues/all/exten/' + encodeURIComponent(user.extension) + '/join', null, opts);
								},
							}, {
								iconName: 'logout',
								text: _('Odhlásit ze všech front'),
								async handle() {
									await REST.POST('queues/all/exten/' + encodeURIComponent(user.extension) +'/leave/', null, opts);
								},
							}],
						});
						PopupManager.show(popup, {
							anchorEl: ev.target,
							forceAxis: 'vertical',
							preferReadingOrder: true,
						});
					},
				}],
			}],
		};
	},

	renderAgentPresence(presence) {
		const hours_to_ms = h => h * 3600 * 1000;

		const call = +presence.call || 0;
		const pause = +presence.pause || 0;
		const free = +presence.free || 0;
		const login = +presence.login || 0;

		const total = call + pause + free + login;
		const width = (
			total > hours_to_ms(6) ? 160 :
				total > hours_to_ms(4) ? 120 :
					total > hours_to_ms(2) ? 80 :
						40
		);

		const getTooltipContent = function (text, total, value, percent) {
			let content = text + ' - ' + Formats.duration_unpadded(typeof value !== 'undefined' ? value : total);
			if (total && typeof percent !== 'undefined') {
				content += ` (${percent}%)`;
			}
			return content;
		};

		// scale items such as the sum of all items is total, all items are rounded to integer and make sure
		const scale_array_rounded = (items, total) => {
			if (items.length === 0) return [];
			const sum = items.reduce((a, b) => a + b);
			const parts = items.map(n => Math.round(n / sum * total));
			const parts_sum = parts.reduce((a, b) => a + b);
			// fix the last item to make the sum to be same as total. There can be a difference due to rounding.
			parts[parts.length - 1] += total - parts_sum;
			return parts;
		};
		const scale_times = (total) => scale_array_rounded([call, pause, free, login], total);

		const [call_percent, pause_percent, free_percent, login_percent] = scale_times(100);

		const title_in_call = getTooltipContent(_('V hovoru'), total, call, call_percent);
		const title_pause   = getTooltipContent(_('V pauze'), total, pause, pause_percent);
		const title_free    = getTooltipContent(_('Volný'), total, free, free_percent);
		const title_login   = getTooltipContent(_('Přihlášen'), total, login, login_percent);
		const title_total   = getTooltipContent(_('Celkem'), total);
		const title_first   = `${_('Čas prvního přihlášení')} - ${Formats.time(presence.login_first_ts)}`;
		const title_last    = `${_('Čas posledního odhlášení')} - ${presence.login_last_ts ? Formats.time(presence.login_last_ts) : ''}`;


		const [call_width, pause_width, free_width, login_width] = scale_times(width);

		return {
			className: 'value agent-statistics-presence',
			children: [{
				className: 'chart',
				style: `width: ${width}px`,
				children: [{
					className: 'in_call',
					style: `width: ${call_width}px`,
					title: title_in_call
				},{
					className: 'pause',
					style: `width: ${pause_width}px`,
					title: title_pause
				},{
					className: 'free',
					style: `width: ${free_width}px`,
					title: title_free
				},{
					className: 'login',
					style: `width: ${login_width}px`,
					title: title_login
				}]
			}, {
				className: 'label',
				children: [
					{ nodeName: 'span', textContent: Formats.duration_short(call) },
					{ nodeName: 'span', textContent: ' | ', className: 'text-muted' },
					{ nodeName: 'span', textContent: Formats.duration_short(pause) },
					{ nodeName: 'span', textContent: ' | ', className: 'text-muted' },
					{ nodeName: 'span', textContent: Formats.duration_short(free) },
					{ nodeName: 'span', textContent: ' | ', className: 'text-muted' },
					{ nodeName: 'span', textContent: Formats.duration_short(login) },
					{ nodeName: 'span', textContent: ' | ', className: 'text-muted' },
					{ nodeName: 'span', textContent: Formats.duration_short(total) },
				],
				title: [
					title_in_call,
					title_pause,
					title_free,
					title_login,
					title_total,
					title_first,
					title_last,
				].join('\n'),
			}],
		}
	},

	renderAgentStatistics(presence, stats) {

		return {
			className: 'agent-statistics',
			children: [{
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					textContent: _('Docházka'),
					className: 'title',
				}, this.renderAgentPresence(presence)],
			}, {
				className: 'agent-statistics-item',
				children: [{
					textContent: _('Celkem hovorů'),
					className: 'title',
				}, {
					textContent: stats.count || 0,
					className: 'value',
				}],
			}, {
				className: 'agent-statistics-item',
				children: [{
					textContent: _('Dovolané'),
					className: 'title',
				}, {
					textContent: stats.count_connected || 0,
					className: 'value',
				}],
			}, {
				className: 'agent-statistics-item',
				children: [{
					textContent: _('Nedovolané'),
					className: 'title',
				}, {
					textContent: stats.count_not_connected || 0,
					className: 'value',
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					textContent: _('Průměrné vyzvánění'),
					className: 'title',
				}, {
					textContent: Formats.duration(stats.avg_ring_duration),
					className: 'value',
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					textContent: _('Průměrný hovor'),
					className: 'title',
				}, {
					textContent: Formats.duration(stats.avg_duration),
					className: 'value',
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					textContent: _('Celková doba hovorů'),
					className: 'title',
				}, {
					textContent: Formats.duration(stats.sum_duration),
					className: 'value',
				}],
			}, {
				className: 'agent-statistics-item',
				children: [{
					textContent: _('Service level'),
					className: 'title hide-on-collapse',
				}, (() => {
					let el = document.gwCreateElement({
						className: 'value agent-statistics-item-graph',
					});

					if (!stats || Object.keys(stats).length === 0) {
						return el;
					}

					Charts.makeDoughnut(el, [{
						label: _('Dovolané'),
						value: stats.count_connected,
						color: 'var(--graph-success-color, green)',
					}, {
						label: _('Nedovolané'),
						value: stats.count_not_connected,
						color: 'var(--graph-error-color, red)',
					}], Formats.percent(stats.service_level_ratio));

					return el;
				})()],
			}],
		};
	},

	renderQueue(user, queue) {
		return {
			nodeName: 'button',
			className: 'queue',
			'attr:disabled': (queue.state == 'unsubscribed' && !queue.visible_for_agent) || undefined,
			'attr:data-status': (user && user.active_calls_queues && user.active_calls_queues.includes(queue.queue)) ? 'in-queue-call' : queue.state, // unsubscribed subscribed paused
			'attr:data-static': queue.static_membership ? '1' : '0',
			'attr:data-type': queue.kind,
			title: queue.static_membership ? 
				_c('Přihlášen trvale', 'queue') : 
				(!queue.visible_for_agent ? _('Agent frontu nemá k dispozici') : undefined),
			children: [{
				className: 'status',
			}, {
				className: 'info' + (!queue.name ? ' no-name' : ''),
				children: [{
					className: 'name',
					textContent: queue.name,
				}, {
					className: 'number',
					textContent: queue.queue + (queue.penalty ? (' (P' + queue.penalty + ')') : ''),
				}],
			}],
			'on:click': async () => {
				if (queue.static_membership) {
					return;
				}

				let opts = {
					activeUserGroup: user.group_id,
				}

				if (queue.state === 'unsubscribed') {
					await REST.POST('queues/' + encodeURIComponent(queue.queue) + '/exten/' + encodeURIComponent(user.extension) + '/join', null, opts);
				} else {
					await REST.POST('queues/' + encodeURIComponent(queue.queue) + '/exten/' + encodeURIComponent(user.extension) + '/leave', null, opts);
				}
			},
		};
	},

	renderAgent(user) {
		return {
			className: 'agent-container panel-container',
			'attr:data-id': user.user_id,
			children: [{
				className: 'agent-info',
				children: [
					this.renderAgentStatus(user),
					this.renderAgentStatistics(user.presence, user.stats),
					{
						nodeName: 'button',
						className: 'collapse-button transparent icon-only small',
						children: [Utils.useIcon('arrow-simple-up')],
					}],
			}, {
				className: 'queue-control-panel wrap',
				children: [{
					className: 'queue-list',
					children: user.queues.map(queue => this.renderQueue(user, queue)),
				}, this.renderAutoHideButton(user.user_id)],
			}],
		};
	},

	saveScrollState() {
		return new Map(Array.from(this.dataEl.querySelectorAll('.queue-list')).map(ql => {
			let agent = ql.closest('.agent-container').dataset.id;

			return [agent, {
				queue_scroll: ql.scrollLeft,
			}];
		}));
	},

	restoreScrollState(state) {
		this.dataEl.querySelectorAll('.queue-list').forEach(ql => {
			let agent = ql.closest('.agent-container').dataset.id;
			let agent_state = state.get(agent);
			if (agent_state) {
				ql.scrollLeft = agent_state.queue_scroll;
			}
		});
	},

	setData(data) {
		this.dataEl.gwReplaceChildren(data.map(user => this.renderAgent(user)));

		this.initAutoHide();
		this.updateTimers();
		this.collapseToggleRefresh();
	},

});

// }}}
// {{{ Supervisor.AgentsScreen

GW.define('Supervisor.AgentsScreen', 'GW.Component', {

	data: null,
	pauseTypes: null,
	contentType: null,

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus toolbar',
			socketSubscriptions: ['call_updates', 'client_connections', 'user_changes', 'queues'],
			children: [{
				className: 'toolbar-top',
				children: [{
					ref: 'filterEl',
					xtype: 'Widgets.ButtonSwitcher',
					cls: "button-switcher small light",
					'on:beforeselect': (c, i) => {
						Application.route({
							paramsFn: params => {
								params.set('filter', i.id);
								return params;
							},
						});
					},
				}, {
					ref: 'fulltextEl',
					nodeName: 'input',
					type: 'search',
					className: 'small',
					placeholder: _('Hledat agenta nebo linku'),
					'on:input': (c, i) => {
						Application.route({
							paramsFn: params => {
								params.set('fulltext', c.target.value);
								return params;
							},
						});
					},
				}, {
					xtype: 'Widgets.ButtonSwitcher',
					ref: 'contentTypeSwitcherEl',
					cls: "button-switcher small light",
					items: [{
						id: 'rows',
						tooltip: _('Chlívečkový'),
						icon: 'dashboard',
					}, {
						id: 'table',
						tooltip: _('Seznamový'),
						icon: 'hamburger',
					}],
					'on:beforeselect': (c, i) => {
						this.contentType = i.id;
						this.contentTypeSwitcherEl.setSelected(i.id);
						localStorage.setItem('supervisor-agents-content-type', i.id);
						
						// changing contentType will change availability if "all groups" item in user group selector
						Application.updateAvailableUserGroups();

						this.reload(); 
					},
				}, {
					ref: 'columnsSettingBtn',
					className: 'flex gap-3',
				}],
			}, {
				ref: 'dataEl',
				className: 'overflow-container',
			}, {
				ref: 'noDataEl',
				className: 'hidden button-switcher-content',
				children: [{
					className: 'agent-container panel-container not-found',
					children: [{
						className: 'not-found-label',
						textContent: _('Zadanému filtru neodpovídá žádný agent'),
					}],
				}],
			}]
		}, this);

		this.contentType = localStorage.getItem('supervisor-agents-content-type') || 'table';
		this.contentTypeSwitcherEl.setSelected(this.contentType);

		this.updateFilters();
		this.loadPauseTypes().then(() => {
			this.reload();
		});
	},

	async loadPauseTypes() {
		let signal = Utils.abortAndRetry(this, 'pause-types-reload');
		this.pauseTypes = await REST.GET('pause-types', {with_groups: 1}, {signal});
		return this.pauseTypes;
	},

	subscribedFilter: user => user.queues.some(q => q.state === 'subscribed' || q.state === 'paused'),

	updateFilters() {
		const total = this.data && this.data.length;
		const subscribed = this.data && this.data.filter(this.subscribedFilter).length;
		const notSubscribed = this.data && (total - subscribed);

		this.filterEl.setItems([{
			id: 'all',
			title: _('Všichni') + (this.data ? ' (' + total + ')' : ''),
		}, {
			id: 'subscribed',
			title: _('Přihlášení') + (this.data ? ' (' + subscribed + ')' : ''),
		}, {
			id: 'not_subscribed',
			title: _('Nepřihlášení') + (this.data ? ' (' + notSubscribed + ')' : ''),
		}]);

		if (!Application.isMobileUI() &&
			// focus only if there is no another focused input
			(!document.activeElement || !['input', 'select', 'button', 'textarea'].includes(document.activeElement.tagName.toLowerCase()))
		) {
			this.fulltextEl.focus();
		}
	},

	updateData() {
		const data = this.data;
		if (!data) {
			return;
		}

		const filter = this.filterEl.getSelected();
		const fulltext = this.fulltextEl.value;

		const filteredData = (data || []).filter(user => {

			let fulltextPredicate = true;

			if (fulltext.length) {
				const fulltextLowerUnaccented = TextUtils.unaccent(fulltext).trim().toLowerCase();
				fulltextPredicate = [TextUtils.unaccent(user.name).toLowerCase(), String(user.extension || "")].some(el => el.includes(fulltextLowerUnaccented));
			}

			if (filter === 'all') {
				return fulltextPredicate && true;
			}

			if (filter === 'subscribed') {
				return fulltextPredicate && this.subscribedFilter(user);
			}

			if (filter === 'not_subscribed') {
				return fulltextPredicate && !this.subscribedFilter(user);
			}
		});

		if (filteredData.length || (this.contentType == 'table' && Application.getActiveUserGroup().id == 'all')) {

			let scrollState;
			if (this.dataContentEl && this.shownContentType == this.contentType) {
				scrollState = this.dataContentEl.saveScrollState();
			} else {
				this.shownContentType = this.contentType;
				this.dataEl.gwReplaceChildren([{
					ref: 'dataContentEl',
					xtype: {
						rows: 'Supervisor.AgentsRows',
						table: 'Supervisor.AgentsTable',
					}[this.contentType],
					pauseTypes: this.pauseTypes,
				}], this);

				if (this.contentType === 'table') {
					this.columnsSettingBtn.gwReplaceChildren([
						this.dataContentEl.renderColumnsSettingsButton(),
						this.dataContentEl.renderExcelExportButton(),
					]);
				} else {
					this.columnsSettingBtn.gwReplaceChildren([]);
				}
			}

			this.dataContentEl.setData(filteredData);

			if (scrollState) {
				this.dataContentEl.restoreScrollState(scrollState);
			}

			this.dataEl.classList.toggle('hidden', false);
			this.noDataEl.classList.toggle('hidden', true);
		} else {
			this.shownContentType = null;
			this.dataEl.gwReplaceChildren([]);

			this.dataEl.classList.toggle('hidden', true);
			this.noDataEl.classList.toggle('hidden', false);
		}
	},

	async reload() {
		let signal = Utils.abortAndRetry(this, 'reload');

		if (this.contentType === 'rows') {
			this.data = await REST.GET('supervisor/queues-agents', null, {signal});
		}
		if (this.contentType === 'table') {
			this.data = await REST.GET('supervisor/queues-agents/table', null, {signal});
		}
		this.updateFilters();
		this.updateData();

		// auto refresh every minute to make presence times up to date (they are updated every minute on BE)
		clearTimeout(this.autoReloadTimeout);
		this.autoReloadTimeout = setTimeout(() => this.reload(), 60000);
	},

	'after:destroy'() {
		clearInterval(this.autoReloadTimeout);
	},

	applyParams(params) {
		const filter = params.get('filter') || 'all';
		const fulltext = params.get('fulltext') || '';

		this.filterEl.setSelected(filter);
		this.fulltextEl.value = fulltext;
		this.updateData();
	},

	onBusMessage(msg) {
		let monitored_msgs = [
			'CALL_CHANGED',
			'CLIENT_CONNECTED',
			'CLIENT_DISCONNECTED',
			'USERS_CHANGED',
			'QUEUES_CHANGED',
		];

		if (monitored_msgs.includes(msg.type)) {
			Utils.dedupeCalls(this, 'reload', 500, () => this.reload());
		}
	},
});

// }}}
// {{{ Supervisor.QueuesScreen

GW.define('Supervisor.QueuesScreen', 'GW.Component', {
	data: null,

	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus toolbar column-panel',
			socketSubscriptions: ['call_updates', 'client_connections', 'user_changes', 'queues'],
			children: [{
				className: 'toolbar-top',
				children: [{
					ref: 'fulltextEl',
					nodeName: 'input',
					type: 'search',
					className: 'small',
					placeholder: _('Hledat název nebo číslo fronty'),
					'on:input': (c, i) => {
						Application.route({
							paramsFn: params => {
								params.set('fulltext', c.target.value);
								return params;
							},
						});
					},
				}, {
					nodeName: 'button',
					className: 'collapse-toggle-button secondary icon-left small',
				}],
			}, {
				className: 'button-switcher-content',
				ref: 'dataEl',
			}]
		}, this);

		this.initCollapseToggle();

		this.reload();
		this.loadPauseTypes();
		this.updateFilters();
	},

	'before:destroy'() {
		this.finiAutoHide();
	},

	getAgentStatus(agent) {
		let state = 'unsubscribed';
		let queueTooltip, agentTooltip;
		let followme = false;

		const onlineState = agent.session_exists ? 'online' : 'offline';
		const onlineTooltip = agent.session_exists ? _('Online') : _('Offline');

		if (agent.state === 'unsubscribed') {
			queueTooltip = _('Nepřihlášen v této frontě');

			if (agent.in_call) {
				agentTooltip = _('Vyzvání');
				state = 'incall-ringing';
			}

			if (agent.in_call_connected) {
				agentTooltip = _('Hovoří');
				state = 'incall-connected';
			}
			
		} else if (agent.state === 'subscribed' || agent.state === 'paused') {
			queueTooltip = agent.static_membership ? _('Trvale přihlášen v této frontě') : _('Přihlášen v této frontě');
			agentTooltip = _('Volný');
			state = 'subscribed';
			
			if (agent.followme) {
				agentTooltip = _('Externí linka');
				followme = true;
			}

			if (agent.state === 'paused') {
				agentTooltip = _('Má pauzu');
				state = 'paused';
			}

			if (agent.in_call) {
				agentTooltip = _('Vyzvání');
				state = 'incall-ringing';
			}

			if (agent.in_call_connected) {
				agentTooltip = _('Hovoří v jiné frontě');
				state = 'incall-connected';
			}

			if (agent.in_call_in_queue) {
				agentTooltip = _('Hovoří v této frontě');
				state = 'incall-inqueue';
			}

			if (!agent.has_device_reachable && !agent.followme) {
				agentTooltip = _('Nemá nastaveno žádné zařízení!');
				state = 'unreachable';
			}
		} else {
			queueTooltip = _('Neznámý stav přihlášení do fronty') + ` [${agent.state}]`;
		}

		return {
			'attr:data-state': state,
			'attr:data-online': onlineState,
			'attr:data-static': agent.static_membership ? '1' : '0',
			'attr:data-followme': followme ? '1' : undefined,
			'title': `${queueTooltip} \n${agentTooltip ? '- ' + agentTooltip + ' ' : ''}(${onlineTooltip})`,
		};
	},

	async loadPauseTypes() {
		let signal = Utils.abortAndRetry(this, 'pause-types-reload');
		this.pauseTypes = await REST.GET('pause-types', null, {signal});
		return this.pauseTypes;
	},

	getAgentMenuItems(queue, agent) {
		return [{
			iconName: agent.state === 'unsubscribed' ? 'login' : 'logout',
			cls: agent.static_membership ? 'disabled' : '',
			text: agent.state === 'unsubscribed' ? _('Přihlásit') : _('Odhlásit'),

			async handle() {
				if (agent.state === 'unsubscribed') {
					await REST.POST('queues/' + encodeURIComponent(queue.queue) + '/exten/' + encodeURIComponent(agent.extension) + '/join');
				} else {
					await REST.POST('queues/' + encodeURIComponent(queue.queue) + '/exten/' + encodeURIComponent(agent.extension) + '/leave');
				}
			},
		}, {
			iconName: agent.state === 'paused' ? 'play' : 'pause',
			cls: !(agent.state === 'subscribed' || agent.state === 'paused') ? 'disabled' : '',
			text: agent.state === 'paused' ?
				(_('Zrušit pauzu') + (agent.pause && agent.pause.pause_type ? ' (' + agent.pause.pause_type.name + ')' : '')) : 
				_('Zapauzovat'),
			
			submenu: agent.state === 'subscribed' && this.pauseTypes && this.pauseTypes.length &&
				this.pauseTypes.map(pauseType => ({
					text: pauseType.name, 
					async handle() {
						await REST.POST('queues/all/exten/' + encodeURIComponent(agent.extension) + '/pause', {
							pause_type: pauseType.id,
						});
					},
				})),

			async handle() {
				if (agent.state === 'subscribed') {
					await REST.POST('queues/all/exten/' + encodeURIComponent(agent.extension) + '/pause');
				} else {
					await REST.POST('queues/all/exten/' + encodeURIComponent(agent.extension) + '/unpause');
				}
			},
		}];
	},

	renderAgent(queue, agent) {
		return {
			className: 'agent queue',
			children: [{
				className: 'status',
				...this.getAgentStatus(agent),
			}, {
				className: 'info',
				children: [{
					className: 'name',
					textContent: agent.name,
				}, {
					className: 'number',
					textContent: agent.extension + (agent.penalty ? (' (P' + agent.penalty + ')') : ''),
				}]
			}, {
				className: 'controls',
				children: [{
					nodeName: 'button',
					className: 'more transparent small',
					children: [Utils.useIcon('vdots')],
					'on:click': async ev => {
						ev.preventDefault();

						let popup = new PopupMenu({
							options: this.getAgentMenuItems(queue, agent),
						});

						PopupManager.show(popup, {
							anchorEl: ev.target,
							forceAxis: 'vertical',
							preferReadingOrder: true,
						});
					},
				}],
			}],
		};
	},

	renderQueueAgentsStatus(queue) {
		function queueStat({tooltip, value, icon, iconCls}) {
			return {
				className: 'status-container button xs icon-left static grey',
				children: [Utils.useIcon(icon, {cls: iconCls}), {
					textContent: value,
				}],
				title: tooltip,
			};
		}

		function countAsFree(agent) {
			if (agent.followme) {
				// skip any further checks
				return Application.getActiveUserGroup().options.free_agent_include_followme;
			}
			if (!agent.has_device_reachable) {
				return false;
			}
			if (Application.getActiveUserGroup().options.free_agent_only_agent_app && !agent.session_exists) {
				return false;
			}
			return true;
		}
		
		return {
			className: 'agent-status',
			children: [{
				className: 'agent-title',
				textContent: [queue.name, queue.queue].filter(v => v).join(' - '),
				title: [queue.name, queue.queue].filter(v => v).join(' - '),
			}, ...[{
				icon: 'headphones',
				iconCls: 'success',
				value: (queue.agents.filter(a => a.state === 'subscribed' || a.state === 'paused').length) +
					'/' + queue.agents.length,
				tooltip: _('Přihlášení agenti / Všichni agenti'),
			}, {
				icon: 'checkmarkcircle',
				iconCls: 'success',
				value: queue.agents.filter(a => a.state === 'subscribed' && !a.in_call && countAsFree(a)).length +
					'/' + queue.agents.filter(a => a.state === 'subscribed' && !a.in_call && a.followme).length,
				tooltip: _('Volných agentů / Agenti na externích linkách'),
			}, {
				icon: 'phone-call',
				iconCls: 'primary',
				value: queue.agents.filter(a => a.in_call && (a.state === 'subscribed' || a.state === 'paused')).length,
				tooltip: _('Probíhající hovory'),
			}, {
				icon: 'pause',
				iconCls: 'warning',
				value: queue.agents.filter(a => a.state === 'paused').length,
				tooltip: _('Agentů v pauze'),
			}, {
				icon: 'hourglass',
				iconCls: 'error',
				value: queue.waiting_calls_count,
				tooltip: _('Čekající hovory'),
			}].map(queueStat)],
		};
	},

	renderQueueAgentsStatistics(queue) {
		const trend = queue.stats.trend;
		let totalIcon = Utils.useIcon(
			      !trend || trend === 0 ? ''      : trend > 0 ? 'arrow-up' : trend < 0 ? 'arrow-down' : 'error',
			{cls: !trend || trend === 0 ? 'muted' : trend > 0 ? 'error'    : trend < 0 ? 'success'    : 'muted'}
		);

		return {
			className: 'agent-statistics',
			children: [{
				className: 'agent-statistics-item',
				children: [{
					className: 'title',
					textContent: _('Celkem hovorů'),
				}, {
					className: 'value',
					children: [{
						textContent: queue.stats.count || 0,
					}, {
						title: trend,
						children: [totalIcon],
					}],
				}],
			}, {
				className: 'agent-statistics-item',
				children: [{
					className: 'title',
					textContent: _('Dovolané'),
				}, {
					className: 'value',
					textContent: queue.stats.count_connected || 0,
				}],
			}, {
				className: 'agent-statistics-item',
				children: [{
					className: 'title',
					textContent: _('Nedovolané'),
				}, {
					className: 'value',
					textContent: queue.stats.count_not_connected || 0,
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					className: 'title',
					textContent: _('Průměrně v IVR'),
				}, {
					className: 'value',
					textContent: Formats.duration(queue.stats.avg_early_duration),
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					className: 'title',
					textContent: _('Průměrné vyzvánění'),
				}, {
					className: 'value',
					textContent: Formats.duration(queue.stats.avg_ring_duration),
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					className: 'title',
					textContent: _('Průměrný hovor'),
				}, {
					className: 'value',
					textContent: Formats.duration(queue.stats.avg_duration),
				}],
			}, {
				className: 'agent-statistics-item hide-on-collapse',
				children: [{
					className: 'title',
					textContent: _('Celková doba hovorů'),
				}, {
					className: 'value',
					textContent: Formats.duration(queue.stats.sum_duration),
				}],
			}, {
				className: 'agent-statistics-item',
				children: [{
					textContent: _('Service level'),
					className: 'title hide-on-collapse',
				}, (() => {
					let el = document.gwCreateElement({
						className: 'value agent-statistics-item-graph',
					});

					if (!queue.stats || Object.keys(queue.stats).length === 0) {
						return el;
					}

					Charts.makeDoughnut(el, [{
						label: _('Dovolané'),
						value: queue.stats.count_connected,
						color: 'var(--graph-success-color, green)',
					}, {
						label: _('Nedovolané'),
						value: queue.stats.count_not_connected,
						color: 'var(--graph-error-color, red)',
					}], Formats.percent(queue.stats.service_level_ratio));

					return el;
				})()],
			}],
		};
	},

	renderQueue(queue) {
		return {
			className: 'agent-container panel-container',
			'attr:data-id': queue.queue,
			children: [{
				className: 'agent-info',
				children: [
					this.renderQueueAgentsStatus(queue),
					this.renderQueueAgentsStatistics(queue),
				{
					nodeName: 'button',
					className: 'collapse-button transparent icon-only small',
					children: [Utils.useIcon('arrow-simple-up')],
				}],
			}, {
				className: 'queue-control-panel wrap',
				children: [{
					className: 'queue-agents queue-list',
					children: queue.agents.map(agent => this.renderAgent(queue, agent)),
				}, this.renderAutoHideButton(queue.queue)],
			}],
		};
	},

	updateData() {
		const fulltext = this.fulltextEl.value;
		
		const filteredData = (this.data || []).filter(queue => {
			
			let fulltextPredicate = true;
		
			if (fulltext.length) {
				const fulltextLowerUnaccented = TextUtils.unaccent(fulltext).trim().toLowerCase();
				fulltextPredicate = [TextUtils.unaccent(String(queue.name || "")).toLowerCase(), TextUtils.unaccent(String(queue.description || "")).toLowerCase(), String(queue.queue || "")].some(el => el.includes(fulltextLowerUnaccented));
			}

			return fulltextPredicate
		})

		let saveScroll = () => {
			let state = new Map(Array.from(this.dataEl.querySelectorAll('.queue-list')).map(ql => {
				let agent = ql.closest('.agent-container').dataset.id;

				return [agent, {
					queue_scroll: ql.scrollLeft,
				}];
			}));

			return () => {
				this.dataEl.querySelectorAll('.queue-list').forEach(ql => {
					let agent = ql.closest('.agent-container').dataset.id;
					let agent_state = state.get(agent);
					if (agent_state) {
						ql.scrollLeft = agent_state.queue_scroll;
					}
				});
			};
		};

		if (this.data) {
			if (filteredData.length) {
				let restore = saveScroll();

				this.dataEl.gwReplaceChildren(filteredData.map(queue => this.renderQueue(queue)));

				restore();
			} else {
				this.dataEl.gwReplaceChildren([{
					className: 'agent-container panel-container not-found',
					children: [{
						className: 'not-found-label',
						textContent: _('Zadanému filtru neodpovídá žádná fronta')
					}],
				}]);
			}
		}

		this.initAutoHide();
		this.collapseToggleRefresh();
	},

	...Supervisor.autoHideMixin(),

	...Supervisor.collapseToggleMixin({
		storageKey: 'supervisor-queues-screen-collapsed',
		itemContainerSelector: '.agent-container',
	}),

	updateFilters() {
		if (!Application.isMobileUI()) {
			setTimeout(()=>this.fulltextEl.focus(), 250);
		}
	},

	async reload() {
		let signal = Utils.abortAndRetry(this, 'reload');

		this.data = await REST.GET('supervisor/queues', null,{signal});
		this.updateData();
	},

	applyParams(params) {
		const fulltext = params.get('fulltext') || '';

		this.fulltextEl.value = fulltext;
		this.updateData();
	},

	onBusMessage(msg) {
		let monitored_msgs = [
			'CALL_CHANGED',
			'CLIENT_CONNECTED',
			'CLIENT_DISCONNECTED',
			'USERS_CHANGED',
			'QUEUES_CHANGED',
		];

		if (monitored_msgs.includes(msg.type)) {
			Utils.dedupeCalls(this, 'reload', 500, () => this.reload());
		}
	},
});

// }}}
// {{{ Supervisor.CallbacksScreen

GW.define('Supervisor.CallbacksScreen', 'Office.AgentCallbackPanel', {
	buttonSwitcherExtraClass: 'light',
	
	showDialButton() {
		// there is no active OfficeManager on supervisor page, do not show dial button
		return false;
	},
});

// }}}
// {{{ Supervisor.QueuesHistoryScreen

GW.define('Supervisor.QueuesHistoryScreen', 'Office.AgentHistoryPanel', {
	buttonSwitcherExtraClass: 'light',

	'wrap:getListComponentConfig'(fn) {
		return {
			...fn(),
			showDialButton() {
				// there is no active OfficeManager on supervisor page, do not show dial button
				return false;
			},
		};
	},

	limitCallsToUserId() {
		// disable filtering by current user - get all available calls by ACL
		return false;
	},
});

// }}}
// {{{ Supervisor.AnnounceScreen

GW.define('Supervisor.AnnounceScreen', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'js-msgbus',
			children: [{
				nodeName: 'h4',
				textContent: _('Oznámení pro tým'),
			},{
				className: 'announcement-cont',
				ref: 'cont',
			}, {
				className: 'new-message',
				children: [{
					nodeName: 'input',
					ref: 'messageInput',
					type: 'text',
					'attr:maxlength': 600,
					placeholder: _('Text oznámení...'),
					$key_Enter: () => this.sendMessage(),
					autofocus: true,
				}, {
					nodeName: 'button',
					type: 'button',
					ref: 'sendButton',
					className: 'primary icon-left',
					children: [Utils.useIcon('send'), _('Odeslat')],
					'on:click': ev => {
						ev.preventDefault();
						this.sendMessage();
					},
				}],
			}]
		}, this);

		this.loadMessages();
		Utils.alignedInterval(this, 'midnight', 'day', 5000, () => this.loadMessages());
	},

	renderAnnouncement(ann, is_last) {
		return {
			className: 'announcement',
			children: [{
				className: 'toolbar',
				children: [{
					className: 'icon-wrapper',
					children: [Utils.useIcon('user')],
				}, {
					className: 'name',
					textContent: ann.sender,
				}, {
					className: 'date',
					textContent: Formats.datetime(ann.created),
				}, {
					nodeName: 'button',
					className: 'resend small secondary icon-left',
					children: is_last && !ann.hidden ? [Utils.useIcon('eyeoff'), _('Skrýt')] : [Utils.useIcon('reload'), _('Odeslat znovu')],
					'on:click': () => {
						if (is_last && !ann.hidden) {
							this.hideAnnouncement(ann.id);
						} else {
							this.messageInput.value = ann.content;
							this.messageInput.focus();
						}
					}
				}]
			}, {
				className: 'content',
				textContent: ann.content,
			}],
		}
	},

	async hideAnnouncement(id) {
		await REST.POST(`announcements/${id}/hide`);
	},

	async loadMessages() {
		const signal = Utils.abortAndRetry(this, 'load');

		const resp = await REST.GET('announcements', null, {signal});

		this.cont.gwReplaceChildren(resp.map((msg, i) => this.renderAnnouncement(msg, i == resp.length - 1)));

		this.cont.scrollTop = this.cont.scrollHeight;
		setTimeout(() => this.cont.scrollTop = this.cont.scrollHeight, 100);
	},

	async sendMessage() {
		if (!this.messageInput.value.trim()) return;
		this.sendButton.disabled = true;
		try {
			await REST.POST('announcements', {
				content: this.messageInput.value
			});
			this.messageInput.value = "";
		} finally {
			this.sendButton.disabled = false;
		}
	},

	onBusMessage(msg) {
		if (msg.type == 'ANNOUNCEMENT_CHANGED') {
			this.loadMessages();
		}
	}
});

// }}}
// {{{ Supervisor.TimeCondsScreen

GW.define('Supervisor.TimeCondsScreen', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			children: [{
				ref: 'list',
				xtype: 'Widgets.EditableItemSelector',
				emptyListText: _('Nemáte žádné časové podmínky'),
				allowCreate: false,
				allowEdit: false,
				allowDelete: false,
				itemApiPath: 'user-conditions',
				itemQueryParam: 'id',
			}, {
				ref: 'cards',
				xtype: 'Widgets.CardSwitcher',
				cls: 'panel-container',
			}]
		}, this);
		this.list.reload();
	},

	async applyParams(params) {
		let {item, items} = await this.list.applyParams(params);

		if (!item) {
			this.cards.show({
				id: 'empty',
				xtype: 'GW.Component',
				initComponent() {
					this.el = document.gwCreateElement({
						className: 'empty',
						children: [{
							nodeName: 'img',
							src: APP_BASE + 'img/empty-boxes.svg',
							className: 'illustration',
						}, {
							nodeName: 'h5',
							textContent: _('Nemáte žádné časové podmínky'),
						}],
					});
				},
			})
			return;
		}

		let card = await this.cards.show({
			id: 'detail',
			xtype: 'Widgets.TimeConditionEditor',
			params,
			async saveDataApi(id, data) {
				await REST.PUT('user-conditions/' + id, {spec: data.spec, type: 'time'});
			},

			async getDataApi(id, {signal}) {
				// assume cond.type == 'time
				return await REST.GET('user-conditions/' + id, null, {signal});
			},
		});

		if (card.loadData) {
			await card.loadData(item);
		}
	},
});


// }}}
// {{{ Supervisor.PlannedQueueMembersScreen

GW.define('Supervisor.PlannedQueueMembersScreen', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'toolbar',
			children: [{
				className: 'toolbar-top',
				children: [{
					ref: 'typeSwitcher',
					xtype: 'Widgets.ButtonSwitcher',
					cls: "button-switcher small light",
					items: [{
						id: 'history',
						title: _('Historie'),
					}, {
						id: 'planned',
						title: _('Plánované'),
					}],
					'on:beforeselect': (c, i) => {
						Application.route({
							paramsFn: params => {
								params.set('type', i.id);
								return params;
							},
						});
					},
				}]
			}, {
				xtype: 'Widgets.CardSwitcher',
				ref: 'cards',
			}],
		}, this);
	},

	applyParams(params) {
		const type = params.get('type') || 'planned';

		this.typeSwitcher.setSelected(type);
		
		this.cards.show({
			id: type,
			xtype: {
				history: 'Supervisor.PlannedQueueMembersScreen.History',
				planned: 'Supervisor.PlannedQueueMembersScreen.Planned',
			}[type],
		});
	},
});

Supervisor.PlannedQueueMembersScreen.defaultColumns = [{
	id: 'user_name',
	name: _('Uživatel'),
	filter: {
		type: 'options',
		showSearch: true,
	},
	sortable: {
		type: 'string',
	},
}, {
	id: 'user_extension',
	name: _('Linka'),
	filter: {
		type: 'options',
		showSearch: true,
	},
	sortable: {
		type: 'string',
	},
}, {
	id: 'queue',
	name: _('Fronta'),
	filter: {
		type: 'options',
		showSearch: true,
	},
	sortable: {
		type: 'string',
	},
	formatCell(td, v, row) {
		td.gwReplaceChildren([{
			':skip': !row.queue_name,
			textContent: row.queue_name,
			className: 'text-nowrap',
		}, {
			textContent: row.queue,
			className: row.queue_name ? 'text-sm' : '',
		}]);
	},
}, {
	id: 'planned_ts',
	name: _('Datum a čas'),
	format: 'datetime',
	sortable: {
		type: 'numeric',
	},
}, {
	id: 'action',
	name: _('Akce'),
	filter: {
		type: 'options',
	},
	sortable: {
		type: 'string',
	},
	formatCell: (td, v, row) => {
		td.textContent = {
			join: _('Přihlásit'),
			leave: _('Odhlásit'),
		}[v];
	},
}]

GW.define('Supervisor.PlannedQueueMembersScreen.History', 'GW.Component', {


	initComponent() {
		this.el = document.gwCreateElement({
			className: 'toolbar',
			children: [{
				ref: 'table',
				xtype: 'FilterableSmartTable',
				getColumns: () => this.getColumns(),
			}]
		}, this);
		this.loadData();
	},

	getColumns() {
		return [...Supervisor.PlannedQueueMembersScreen.defaultColumns, {
			id: 'result',
			name: _('Výsledek'),
			filter: {
				type: 'options',
			},
			sortable: {
				type: 'string',
			},
			formatCell: (td, v, row) => {
				td.textContent = {
					success: _('Úspěšně provedeno'),
					fail: _('Chyba'),
					expired: _('Nezpracováno'),
				}[v];
			},
		}, {
			id: 'result_error',
			name: _('Popis chyby'),
			filter: {
				type: 'options',
			},
			sortable: {
				type: 'string',
			},
		}];
	},

	async loadData() {
		const signal = Utils.abortAndRetry(this, 'load');

		const data = await REST.GET('planned-queue-members/history', null, {signal});

		this.table.setData(data);
	},
	
});

GW.define('Supervisor.PlannedQueueMembersScreen.Planned', 'GW.Component', {
	initComponent() {
		this.el = document.gwCreateElement({
			className: 'toolbar',
			children: [{
				className: 'toolbar-top',
				children: [{
					nodeName: 'button',
					className: 'secondary small',
					textContent: _('Přidat plánované přihlášení'),
					'on:click': ev => {
						this.showEditForm(null);
					},
				}, {
					nodeName: 'button',
					className: 'secondary small',
					textContent: _('Smazat vše'),
					'on:click': ev => {
						let me = this;
						new Main.ConfirmDialog({
							title: _('Opravdu smazat všechny naplánované akce?'),
							subtitle: _('Tato akce nelze vzít zpět.'),
							async onSave() {
								await REST.DELETE(`planned-queue-members/all`);
								await me.loadData();
							},
						});
					},
				}, {
					nodeName: 'button',
					className: 'secondary small',
					textContent: _('Exportovat XLSX'),
					'on:click': async ev => {
						let group = Application.getActiveUserGroup();
						const params = new URLSearchParams();
						if (group) {
							params.set('active_user_group', group.id);
						}
						location.href = API_BASE + 'planned-queue-members/export/xlsx?' + params.toString();
					},
				}, {
					nodeName: 'button',
					className: 'secondary small',
					textContent: _('Nahrát soubor (.XLSX)'),
					'on:click': async ev => {
						let file = await Uploads.fileSelect('.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
						if (file) {
							this.importXlsx(file);
						}
					},
				}]
			},{
				ref: 'table',
				xtype: 'FilterableSmartTable',
				getColumns: () => this.getColumns(),
				renderRow: (tr, row) => {
					tr.classList.toggle('invalid', !row.valid);
				},
			}]
		}, this);
		this.loadData();
	},
	
	getColumns() {
		const me = this;
		return [...Supervisor.PlannedQueueMembersScreen.defaultColumns, {
			id: 'ctl',
			formatCell: (td, v, row) => {
				td.gwReplaceChildren([{
					nodeName: 'button',
					className: 'secondary icon-only small',
					'attr:disabled': row.valid ? undefined : true,
					title: row.valid ? _('Upravit') : _('Plánované přihlašení není validní (fronta není dostupná pro daného agenta)'),
					children: [Utils.useIcon('edit')],
					'on:click': async ev => {
						me.showEditForm(row);
					},
				}, {
					nodeName: 'button',
					className: 'secondary icon-only small',
					title: _('Smazat'),
					children: [Utils.useIcon('delete')],
					'on:click': async ev => {
						me.onDelete(row);
					},
				}]);
			},
		}];
	},

	onDelete(item) {
		let me = this;
		new Main.ConfirmDialog({
			title: _('Opravdu smazat naplánovanou akci?'),
			subtitle: _('Tato akce nelze vzít zpět.'),
			async onSave() {
				await REST.DELETE(`planned-queue-members/${item.id}`);
				me.loadData();
			},
		});
	},
	
	async loadData() {
		const signal = Utils.abortAndRetry(this, 'load');

		const data = await REST.GET('planned-queue-members/planned', null, {signal});

		this.table.setData(data);
	},
	
	showEditForm(existing) {
		let me = this;
		
		let dlg = new Main.FormDialog({
			title: existing ? _('Upravit naplánované přihlášení') : _('Nové naplánované přihlášení'),

			renderFormFields() {
				return [{
					xtype: 'SelectField',
					ref: 'userIdEl',
					name: 'user_id',
					label: _('Agent'),
					getOptions: ({signal}) => REST.GET('planned-queue-members/users', null, {signal})
						.then(users => users.map(({id, name, extension}) => ({
							value: id, 
							text: extension ? `${name} - ${extension}` : name,
						})))
				}, {
					xtype: 'SelectField',
					name: 'queue',
					label: _('Fronta'),
					getOptions: ({signal}) => (async () => {
							const user_id = dlg.userIdEl.getValue();
							if (!user_id) {
								return [];
							}
							return await REST.GET(`planned-queue-members/queues/${user_id}`, null, {signal})
						})()
						.then(queues => queues.map(({queue, name}) => ({
							value: queue, 
							text: name ? `${queue} - ${name}` : queue,
						}))),
				}, {
					xtype: 'TextField',
					name: 'planned_ts',
					label: _('Datum a čas'),
					type: 'datetime-local',
				}, {
					xtype: 'SelectField',
					name: 'action',
					label: _('Akce'),
					options: [{
						value: 'join',
						text: _('Přihlásit'),
					}, {
						value: 'leave',
						text: _('Odhlásit'),
					}],
				}];
			},

			async onSave(data) {
				if (existing) {
					await REST.PUT('planned-queue-members/' + existing.id, data);
				} else {
					await REST.POST('planned-queue-members/', data);
				}
				me.loadData();
			},
		});
		
		if (existing) {
			dlg.setFormFieldsData(existing);
		}
	},
	
	async importXlsx(file) {
		let res = await Uploads.uploadFile('planned-queue-members/import/xlsx', file, {
			headers: {
				'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
				'X-Active-User-Group': Application.getActiveUserGroup().id,
			},
		});
		Application.notify({
			kind: 'success',
			text: _n(res.inserted, 'Importováno {n} záznamů') + 
				(res.errors.length ? (', ' + _n(res.errors.length, '{n} záznamů se importovat nepodařilo')) : ''),
			timeout: 5000,
		});
		this.loadData();
	},
});

// }}}
// {{{ Supervisor.CallRatingsScreen

GW.define('Supervisor.CallRatingsScreen', 'GW.Component', {
	
	users: [],

	initComponent() {
		const me = this;
		this.el = document.gwCreateElement({
			className: 'js-msgbus column-panel',
			socketSubscriptions: ['call_ratings'],
			children: [{
				className: 'toolbar',
				children: [{
					className: "toolbar-top",
					children: [{
						// @TODO: Add autocomplete (name,number) here? Pretty much useless without it when large amount of agents are present
						ref: 'filterRefUser',
						xtype: 'SelectField',
						popupAutoWidth: false,
						cls: 'small',
						value: 'all',
						async getOptions({signal}) {
							const [users, changed] = await Utils.cache(this, 'users', 60000, REST.GET, 'call-ratings/users', null, {signal});
							if (changed) {
								me.users = users;
								me.applyParams(new URLSearchParams(location.search));
							}
							return [{
								value: 'all',
								text: _('Všichni agenti'),
							}, ...users.map(u => ({
								value: u.id,
								text: u.name,
							}))];
						},
						'on:change': c => {
							Application.route({
								paramsFn: params => {
									params.set('rating_ref_user', c.getValue());
									return params;
								},
							});
						},
					}, {
						ref: 'filterRated',
						xtype: 'Widgets.ButtonSwitcher',
						cls: "button-switcher light small",
						items: [{
							id: 'all',
							value: 'all',
							title: _('Vše'),
						}, {
							id: 'no',
							value: 'no',
							title: _('Nehodnocené'),
						}, {
							id: 'yes',
							value: 'yes',
							title: _('Hodnocené'),
						}],
						'on:beforeselect': (c, i) => {
							Application.route({
								paramsFn: params => {
									this.filterRated.setSelected(i.value)
									params.set('rating_rated', i.value);
									return params;
								},
							});
						},
					}]
				}]
			}, {
				ref: 'cards',
				xtype: 'Widgets.CardSwitcher',
			}],
		}, this);
		// reload queues only if queue manager is not active. The queues may be not loaded or outdated in this cases.
		if (!Office.QueueManager.active) {
			Office.QueueManager.loadQueues(false);
		}
	},

	async applyParams(params) {
		let queues = Office.QueueManager.queues;
		let users = this.users;

		if (queues.length == 0 || users.length == 0) {
			// nothing to filter by, nothing to load
			this.cards.show({
				id: 'no-data',
				initComponent() {
					this.el = document.gwCreateElement({
						className: 'empty',
						textContent: _('Žádná data nejsou k dispozici'),
					});
				},
			});
			return;
		}

		const query = {
			queue: Office.QueueManager.queues.map(q => q.queue).join(','),
			has_recordings: true,
			include_ratings: true,
		};

		let user_id = params.get('rating_ref_user') || 'all';
		this.filterRefUser.setValue(user_id);

		if (user_id !== 'all') {
			query.user_id = user_id;
		} else if (this.users) {
			query.user_id = this.users.map(u => u.id).join(',');
		}

		let rated = params.get('rating_rated') || 'all';
		this.filterRated.setSelected(rated);

		if (rated !== 'all') {
			query.rated = rated;
		}

		let c = await this.cards.show({
			id: 'table', 
			xtype: 'Office.CallsTable',
			showDialButton() {
				// there is no active OfficeManager on supervisor page, do not show dial button
				return false;
			},

			'wrap:getColumns'(fn) {
				const columns = fn();
				// add ratings column as penultimate ("last but one" - not last as overflow doesn't work correctly)
				columns.splice(-1, 0, {
					id: 'ratings',
					name: _('Hodnocení'),
					formatCell(td, v, row) {
						if (row.ratings && row.ratings.length > 0) {
							// rating exists
							td.gwReplaceChildren([{
								title: _('Hodnoceno'),
								className: 'button small secondary icon-only static cursor-help',
								children: [Utils.useIcon('check', {cls: 'text-muted'})],
							}]);
						} else if (row.rated === false) {
							// explicitly marked as not rated
							td.gwReplaceChildren([{
								title: _('Nehodnoceno'),
								className: 'button small secondary icon-only static cursor-help',
								children: [Utils.useIcon('error', {cls: 'text-muted'})],
							}]);
						} else {
							// not yet rated
							td.gwReplaceChildren([{
								nodeName: 'button',
								className: 'button small error-secondary icon-only',
								children: [Utils.useIcon('error')],
								title: _('Nehodnotit'),
								'on:click': async () => {
									await REST.POST(`calls/${row.id}/rating/unrate`);
								},
							}]);
						}
					},
				});
				return columns;
			}
		});
		
		await c.loadCalls(query, true);
	},

	onBusMessage(msg) {
		if (msg.type === 'QUEUE_MANAGER_QUEUES_LIST_CHANGE' || msg.type == 'CALL_RATINGS_CHANGE') {
			this.applyParams(new URLSearchParams(location.search));
		}
	},

});

// }}}

Application.addRoutes([{
	group: 'auth',
	module: 'supervisor',
	path: APP_BASE + 'supervisor',
	async handler({params}) {
		let c = Application.show({
			id: 'supervisor.overview',
			xtype: 'Supervisor.OverviewScreen',
		});

		params.set('screen', 'active-calls');
		c.applyParams(params);
	}
}, {
	group: 'auth',
	module: 'supervisor',
	path: APP_BASE + 'supervisor/{screen:str}',
	async handler({params, captures}) {
		let c = Application.show({
			id: 'supervisor.overview',
			xtype: 'Supervisor.OverviewScreen',
		});

		params.set('screen', captures.screen);
		c.applyParams(params);
	},
	isAllGroupsAllowed({captures}) {
		return captures.screen == 'agents' &&
			(localStorage.getItem('supervisor-agents-content-type') || 'table') == 'table';
	}
}]);

Application.registerModule({
	id: 'supervisor',
	title: _('Supervizor panel'),
	tagline: _('Přehled agentů, front a aktuálních hovorů'),
	icon: 'eye',
	href: APP_BASE + 'supervisor/',
});
